<template>
  <long-query-layout
    :resource-name="resourceName"
    :query-filter="queryFilter"
    :map-query-filter-for-api="mapQueryFilterForApi"
    :apply-query-filter="applyQueryFilter"
    :active-tab.sync="activeTab"
    :customers.sync="customerCollection"
    :excel-properties-handler="excelPropertiesHandler.bind(this)"
    :on-query-completed="onQueryCompleted"
    :customer-download-only="true"
    @query-completed="loadData"
    @result-area-size-change="updateTableSize"
    @query-id-change="queryId = $event"
  >
    <!-- -------------------------------------------------------- -->
    <!-- ヘッダのアクション -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:header-actions="slotProps">
      <div v-if="experimentalAi.enabled">
        <md-menu md-direction="bottom-start">
          <gl-button icon-pre="experimental" md-menu-trigger>
            AIエージェント
          </gl-button>
          <md-menu-content>
            <md-menu-item disabled>
              プレビュー機能
            </md-menu-item>
            <!-- ---------------------------------- -->
            <div
              class="
                experimental-ai-menu-section
                experimental-ai-menu-section--bordered
              "
            >
              顧客理解
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="experimentalAiMenuItemTooltip('segmentDescription')"
              gl-tooltip-position="top"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled('segmentDescription')
                "
                @click="openExperimentalAiDialog('segmentDescription')"
              >
                目的範囲・選択範囲のニーズ要約
              </md-menu-item>
            </div>
            <!-- ---------------------------------- -->
            <div
              class="
                experimental-ai-menu-section
                experimental-ai-menu-section--bordered
              "
            >
              品揃え
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="
                experimentalAiMenuItemTooltip('cutCandidateRecommendation')
              "
              gl-tooltip-position="left"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled('cutCandidateRecommendation')
                "
                @click="openExperimentalAiDialog('cutCandidateRecommendation')"
              >
                カット候補商品のレコメンド
              </md-menu-item>
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="experimentalAiMenuItemTooltip('newItemSuggestion')"
              gl-tooltip-position="left"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled('newItemSuggestion')
                "
                @click="openExperimentalAiDialog('newItemSuggestion')"
              >
                採用すべき新商品の推論
              </md-menu-item>
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="
                experimentalAiMenuItemTooltip('newItemPositionSuggestion')
              "
              gl-tooltip-position="left"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled('newItemPositionSuggestion')
                "
                @click="openExperimentalAiDialog('newItemPositionSuggestion')"
              >
                新商品の陳列位置の推論
              </md-menu-item>
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="
                experimentalAiMenuItemTooltip('recommendNonSalesStores')
              "
              gl-tooltip-position="left"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled('recommendNonSalesStores')
                "
                @click="openExperimentalAiDialog('recommendNonSalesStores')"
              >
                重点商品実績なし店舗一覧出力
              </md-menu-item>
            </div>
            <!-- ---------------------------------- -->
            <div
              class="
                experimental-ai-menu-section
                experimental-ai-menu-section--bordered
              "
            >
              棚割
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="
                experimentalAiMenuItemTooltip('planogramSoftwareColoringFile')
              "
              gl-tooltip-position="left"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled(
                    'planogramSoftwareColoringFile',
                  )
                "
                @click="
                  openExperimentalAiDialog('planogramSoftwareColoringFile')
                "
              >
                棚割ソフト色分用ファイル出力
              </md-menu-item>
            </div>
            <!-- ---------------------------------- -->
            <div
              class="
                experimental-ai-menu-section
                experimental-ai-menu-section--bordered
              "
            >
              販促
            </div>
            <div
              class="experimental-ai-menu-item"
              :gl-tooltip="
                experimentalAiMenuItemTooltip('couponTargetCustomerFile')
              "
              gl-tooltip-position="left"
            >
              <md-menu-item
                :disabled="
                  isExperimentalAiMenuItemDisabled('couponTargetCustomerFile')
                "
                @click="openExperimentalAiDialog('couponTargetCustomerFile')"
              >
                クーポンターゲット顧客出力
              </md-menu-item>
            </div>
          </md-menu-content>
        </md-menu>
      </div>
      <div>
        <gl-button raised @click="openReportEditDialog('')">
          顧客接点追加パラメーター設定
        </gl-button>
      </div>
      <div>
        <md-menu md-direction="bottom-start">
          <gl-button raised md-menu-trigger :accent="isUserSelectingManualCut">
            手動採用／不採用切替（{{ manualCut.candidates.length }} /
            {{ leafTotalCount }}）
          </gl-button>
          <md-menu-content>
            <md-menu-item
              :disabled="!isUserSelectingManualCut"
              @click="applyManualCut"
            >
              <span
                :style="{
                  color: !isUserSelectingManualCut
                    ? 'inherit'
                    : 'var(--color-primary)',
                }"
              >
                採用／不採用の選択を確定する
              </span>
            </md-menu-item>
            <md-menu-item
              :disabled="!isUserSelectingManualCut"
              @click="resetManualCut"
            >
              前回確定した状態に戻す
            </md-menu-item>
            <md-menu-item
              :disabled="manualCutCandidateAndIds.length === 0"
              @click="clearManualCut(false)"
            >
              選択を全てクリアする
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
      <div style="margin-left: var(--spacing-medium);">
        <gl-switch :value="isDetail" @input="toggleDetail">詳細</gl-switch>
      </div>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析条件 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:filter>
      <!-- 顧客接点 -->
      <query-filter-element id="leaf" title="顧客接点" contentWidth="large">
        <div style="display: flex; align-items: center;">
          <md-field style="width: 180px; margin-right: var(--spacing-medium);">
            <md-select v-model="queryFilter.leaf.type">
              <md-option
                v-for="t in leafTypesOrdered"
                :key="t.id"
                :value="t.id"
                :disabled="!isTheLeafSelectable(t.id).selectable"
                :gl-tooltip="
                  !isTheLeafSelectable(t.id).selectable
                    ? isTheLeafSelectable(t.id).reason
                    : ''
                "
              >
                {{ t.label }}
              </md-option>
            </md-select>
          </md-field>
          <div>を顧客接点として分析する</div>
        </div>
        <div style="display: flex;">
          <div style="margin-right: var(--spacing-small);">
            <md-icon>info</md-icon>
          </div>
          <div style="color: var(--color-secondary-text);">
            <div>
              選択した顧客接点間の関係を分析します。分析対象マーケット構成単品／分類を分類で指定する場合でも、単品間の関係性を分析するならば顧客接点は「単品」を選択してください。
            </div>
            <div>
              また、選択した顧客接点の値は3つ以上必要です。例えば、顧客接点に「分類」を選択した場合3分類以上選択してください。同様に、顧客接点に「店舗」を選択した場合3店舗以上選択してください。ただし、顧客接点となるものを3つ以上選択したとしても、買い上げがない場合や利用ID数の制限設定で分析対象とならない顧客接点が含まれる場合があります。その結果、分析に必要な顧客接点が足りず結果が出力されないことがあります。
            </div>
          </div>
        </div>

        <div>
          <div style="display: flex; align-items: center;">
            <div style="margin-right: var(--spacing-medium);">利用ID数が</div>
            <div
              class="input-inline"
              style="margin-right: var(--spacing-medium);"
            >
              <md-field class="input-inline__field input-inline__field--medium">
                <md-input
                  v-model.number="queryFilter.leaf.minCustomerCount"
                  type="number"
                  :min="1"
                  required
                ></md-input>
              </md-field>
            </div>
            <div style="flex: 1;">未満の顧客接点を処理に含めない</div>
          </div>
        </div>
        <div>
          <div class="title">
            <gl-sub-text>業務別追加表示項目</gl-sub-text>
            <span class="option-changeable">
              <md-icon>info</md-icon>
            </span>
          </div>

          <div style="display: flex; align-items: center">
            <md-field>
              <md-select
                v-model="queryFilter.leaf.columns[queryFilter.leaf.type]"
                multiple
              >
                <md-option
                  v-for="c in _additionalColumns"
                  :key="c.id"
                  :value="c.id"
                  :disabled="c.hidden"
                >
                  {{ c.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <span
            style="margin-left: var(--spacing-medium); font-size: var(--font-size-small);"
          >
            <a
              href="#"
              @click.prevent="resetColumnSelection()"
              style="word-break: keep-all;"
            >
              {{ leafTypeLabels[queryFilter.leaf.type] }}の初期設定に戻す
            </a>
          </span>
        </div>
      </query-filter-element>

      <!-- 期間 -->
      <query-filter-element
        id="term"
        title="顧客利用期間"
        contentWidth="medium"
      >
        <filter-term
          v-bind.sync="queryFilter.term"
          :default-week-count="13"
          :max="371"
        />
      </query-filter-element>

      <!-- マーケット構成単品／分類 -->
      <query-filter-element
        id="item-shin-tapir"
        title="マーケット構成単品／分類"
        contentWidth="medium"
      >
        <gl-select-company :company.sync="itemCompany" />

        <div v-if="queryFilter.leaf.type !== 'itemCategory'">
          <div>
            <md-radio
              v-model="queryFilter.marketItems.item.selectMode"
              value="category"
            >
              分類
              <gl-sub-text>で指定</gl-sub-text>
            </md-radio>
            <md-radio
              v-model="queryFilter.marketItems.item.selectMode"
              value="item"
            >
              単品
              <gl-sub-text>で指定</gl-sub-text>
            </md-radio>
          </div>
          <filter-item-category
            v-if="queryFilter.marketItems.item.selectMode === 'category'"
            v-bind.sync="queryFilter.marketItems.item"
          />
          <filter-item
            v-if="queryFilter.marketItems.item.selectMode === 'item'"
            v-bind.sync="queryFilter.marketItems.item"
          />
        </div>
        <div v-if="queryFilter.leaf.type === 'itemCategory'">
          <filter-category
            :company="queryFilter.marketItems.category.company"
            v-bind.sync="queryFilter.marketItems.category"
          />
        </div>
      </query-filter-element>

      <!-- 店舗 -->
      <query-filter-element
        id="store"
        title="マーケット構成店舗"
        contentWidth="medium"
      >
        <filter-store v-bind.sync="queryFilter.store" />
      </query-filter-element>

      <!-- オプション -->
      <query-filter-element
        id="option-shin-tapir"
        title="オプション"
        contentWidth="large"
      >
        <div class="title">
          <gl-sub-text>採用順算出ベース</gl-sub-text>
          <span class="option-changeable">
            <md-icon>info</md-icon>
          </span>
        </div>
        <div style="width: 200px">
          <md-field>
            <md-select v-model="queryFilter.option.adoptOrder">
              <md-option v-for="o in adoptOrders" :key="o.id" :value="o.id">{{
                o.label
              }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="title">
          <gl-sub-text>採用順降下</gl-sub-text>
          <span class="option-changeable">
            <md-icon>info</md-icon>
          </span>
        </div>
        <div>
          <div>
            <md-checkbox
              v-model="
                queryFilter.option.orderAdjustment.optionsInSelection.selected
              "
            >
              1. 選択範囲（ニーズ）中の選択肢数
            </md-checkbox>
          </div>
          <div
            class="option-sub-box"
            v-if="
              queryFilter.option.orderAdjustment.optionsInSelection.selected
            "
          >
            <div style="display: flex; align-items: center;">
              <div style="margin-right: var(--spacing-medium);">
                選択範囲（ニーズ）中の選択肢数が最大
              </div>
              <div
                class="input-inline"
                style="margin-right: var(--spacing-medium);"
              >
                <md-field
                  class="input-inline__field input-inline__field--small"
                >
                  <md-input
                    v-model.number="
                      queryFilter.option.orderAdjustment.optionsInSelection
                        .value
                    "
                    type="number"
                    :min="1"
                    :step="1"
                    required
                  ></md-input>
                </md-field>
              </div>
              <div>
                となるよう採用順を調整する
              </div>
            </div>
            <div>
              <div>
                <gl-sub-text
                  >最大値（9=7+2）：最も安全な品揃え基準。最大パターンの棚割時に利用。（デフォルト）</gl-sub-text
                >
              </div>
              <div>
                <gl-sub-text
                  >中央値（7）：顧客認知、品揃えの絞り込みの攻守のバランスに優れた基準点。</gl-sub-text
                >
              </div>
              <div>
                <gl-sub-text
                  >最小値（5=7-2）：品揃えを極力絞り込みたい場合に利用。</gl-sub-text
                >
              </div>
              <div>
                <gl-sub-text
                  >1〜4の指定も可能だが、欠品防止の観点からの最小値は2。</gl-sub-text
                >
              </div>
            </div>
          </div>

          <div>
            <md-checkbox
              v-model="
                queryFilter.option.orderAdjustment.unnecessarySelection.selected
              "
            >
              2. 不要選択範囲（ニーズ）
            </md-checkbox>
          </div>
          <div
            class="option-sub-box"
            v-if="
              queryFilter.option.orderAdjustment.unnecessarySelection.selected
            "
          >
            <div style="display: flex; align-items: center;">
              <div style="margin-right: var(--spacing-medium);">
                利用者率が
              </div>
              <div
                class="input-inline"
                style="margin-right: var(--spacing-medium);"
              >
                <md-field
                  class="input-inline__field input-inline__field--small"
                >
                  <md-input
                    v-model.number="
                      queryFilter.option.orderAdjustment.unnecessarySelection
                        .value
                    "
                    type="number"
                    :step="0.01"
                    :min="0"
                    required
                  ></md-input>
                </md-field>
              </div>
              <div>
                %未満の選択範囲（ニーズ）の選択肢の採用順を一律下げる
              </div>
            </div>
            <div>
              <div><gl-sub-text> デフォルトは0.01%。 </gl-sub-text></div>
              <div>
                <gl-sub-text
                  >経済合理性と人間科学的受容限界の交差点。市場成立の最小条件。</gl-sub-text
                >
              </div>
              <div>
                <gl-sub-text>但し、各店での取扱の有無に留意。</gl-sub-text>
              </div>
            </div>
          </div>
          <div
            v-if="
              queryFilter.option.orderAdjustment.optionsInSelection.selected &&
                queryFilter.option.orderAdjustment.unnecessarySelection.selected
            "
            style="display: flex; align-items: center;"
          >
            <div
              style="word-break: keep-all; margin-right: var(--spacing-medium);"
            >
              降下処理順序は
            </div>
            <div style="width: 300px">
              <md-field>
                <md-select
                  v-model="queryFilter.option.orderAdjustment.priority"
                >
                  <md-option value="optionsInSelection">1 → 2 の順</md-option>
                  <md-option value="unnecessarySelection">2 → 1 の順</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div
            v-if="
              queryFilter.option.orderAdjustment.optionsInSelection.selected ||
                queryFilter.option.orderAdjustment.unnecessarySelection.selected
            "
            style="display: flex; align-items: center;"
          >
            <md-checkbox
              v-model="queryFilter.option.orderAdjustment.cutWhenApplicable"
            >
              cut判定の自動実行（1, 2に該当する選択肢を全てcut判定とする）
            </md-checkbox>
          </div>
        </div>

        <div>
          <gl-sub-text>フェイシング数と補充サイクル</gl-sub-text>
        </div>
        <div style="margin-left: var(--spacing-large)">
          <div style="display: flex; align-items: center;">
            <div style="margin-right: var(--spacing-medium);">
              最大
            </div>
            <div
              class="input-inline"
              style="margin-right: var(--spacing-medium);"
            >
              <md-field class="input-inline__field input-inline__field--small">
                <md-input
                  v-model.number="queryFilter.option.facingMax"
                  type="number"
                  :step="1"
                  :min="1"
                  required
                ></md-input>
              </md-field>
            </div>
            <div>
              フェイシング
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <div style="margin-right: var(--spacing-medium);">
              最低
            </div>
            <div
              class="input-inline"
              style="margin-right: var(--spacing-medium);"
            >
              <md-field class="input-inline__field input-inline__field--small">
                <md-input
                  v-model.number="queryFilter.option.facingMin"
                  type="number"
                  :step="1"
                  :min="1"
                  required
                ></md-input>
              </md-field>
            </div>
            <div>
              フェイシング
            </div>
          </div>
          <div style="margin-top: var(--spacing-x-small);">
            <div>
              <gl-sub-text>
                最大値（5=3+2）：顧客認知の限界点。作業頻度を低減したい際に利用。（デフォルト）
              </gl-sub-text>
            </div>
            <div>
              <gl-sub-text>
                中央値（3）：顧客認知、在庫維持の攻守のバランスに優れた基準点。
              </gl-sub-text>
            </div>
            <div>
              <gl-sub-text>
                最小値（1=3-2）：顧客認知の下限。
              </gl-sub-text>
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <div style="margin-right: var(--spacing-medium);">
              補充サイクル
            </div>
            <div
              class="input-inline"
              style="margin-right: var(--spacing-medium);"
            >
              <md-field class="input-inline__field input-inline__field--small">
                <md-input
                  v-model.number="queryFilter.option.restockCycleDays"
                  type="number"
                  :step="1"
                  :min="1"
                  required
                ></md-input>
              </md-field>
            </div>
            <div>
              日間
            </div>
          </div>
        </div>

        <div>
          <gl-sub-text>在庫係数</gl-sub-text>
        </div>
        <div style="margin-left: var(--spacing-large)">
          <div style="width: 500px;">
            <div
              style="
                display: flex;
                align-items: center;
                margin-bottom: var(--spacing-x-small);
              "
            >
              <div
                style="margin-right: var(--spacing-medium); white-space: nowrap;"
              >
                全体
              </div>
              <div style="flex: 1; margin-right: var(--spacing-medium);">
                <md-field style="width: 100%;">
                  <md-input
                    v-model.number="queryFilter.option.stockCoefficientAll"
                    type="number"
                    :step="0.1"
                    :min="0"
                    required
                  ></md-input>
                </md-field>
              </div>
              <div>
                倍
              </div>
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                margin-bottom: var(--spacing-x-small);
              "
            >
              <div style="width: 50%; text-align: center;">
                ×
              </div>
              <div style="width: 50%; text-align: center;">
                ×
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <div
                style="
                  width: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="margin-right: var(--spacing-medium);">
                  1stレコメンド
                </div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="queryFilter.option.stockCoefficient1st"
                      type="number"
                      :step="0.1"
                      :min="0"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div>
                  倍
                </div>
              </div>
              <div
                style="
                  width: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="margin-right: var(--spacing-medium);">
                  2ndレコメンド
                </div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="queryFilter.option.stockCoefficient2nd"
                      type="number"
                      :step="0.1"
                      :min="0"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div>
                  倍
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="title">
          <gl-sub-text>R／T顧客定義</gl-sub-text>
        </div>
        <div style="display: flex; align-items: center;">
          <div
            class="input-inline"
            style="margin-right: var(--spacing-medium);"
          >
            <md-field class="input-inline__field input-inline__field--medium">
              <md-input
                v-model.number="queryFilter.option.r"
                type="number"
                :min="2"
                required
              ></md-input>
            </md-field>
          </div>
          <div>
            <div>
              回以上利用者をR顧客、
            </div>
            <div>
              回未満利用者をT顧客に区分する
            </div>
          </div>
        </div>

        <div v-if="queryFilter.leaf.type === 'priceLine'">
          <div class="title">
            <gl-sub-text>プライスライン</gl-sub-text>
          </div>
          <div>
            <md-field>
              <md-select v-model="queryFilter.option.priceLine">
                <md-option :value="1000">1,000円単位（100の位切捨）</md-option>
                <md-option :value="100">100円単位（10の位切捨）</md-option>
                <md-option :value="10">10円単位（1の位切捨）</md-option>
                <md-option :value="1">1円単位（小数点以下切上）</md-option>
              </md-select>
            </md-field>
          </div>
        </div>

        <div v-if="queryFilter.leaf.type === leafTypes.time">
          <div class="title">
            <gl-sub-text>時間帯</gl-sub-text>
          </div>
          <div>
            <md-field style="width: 200px;">
              <md-select v-model="queryFilter.option.minuteStep">
                <md-option :value="1">1分単位</md-option>
                <md-option :value="5">5分単位</md-option>
                <md-option :value="10">10分単位</md-option>
                <md-option :value="20">20分単位</md-option>
                <md-option :value="30">30分単位</md-option>
                <md-option :value="60">1時間単位</md-option>
              </md-select>
            </md-field>
          </div>
        </div>

        <!-- <div class="dangerous-option">
          <md-checkbox
            v-model="
              queryFilter.option.usePotentiallyDangerousShinKappaDistCalc
            "
          >
            シンKappaの距離算出ロジックを使う
          </md-checkbox>
          <div>
            シンKappaの距離算出ロジックは、分析条件の範囲が広いと<span
              :style="{
                color: queryFilter.option
                  .usePotentiallyDangerousShinKappaDistCalc
                  ? 'red'
                  : 'inherit',
              }"
              >スキャン量・消費リソースが莫大になる傾向があります</span
            >。旧Kappaの距離算出ロジックと比較するために、内部利用段階でのみ選択可能にしています。
          </div>
          <div
            v-if="queryFilter.option.usePotentiallyDangerousShinKappaDistCalc"
            style="display: flex; align-items: center;"
          >
            <div>
              シンKappa距離算出ロジックの標本ID数：
            </div>
            <div
              class="input-inline"
              style="margin-right: var(--spacing-medium);"
            >
              <md-field class="input-inline__field input-inline__field--medium">
                <md-input
                  v-model.number="
                    queryFilter.option.shinKappaCustomerSamplingMax
                  "
                  type="number"
                  :min="2"
                  required
                ></md-input>
              </md-field>
            </div>
            <div>
              ID（0 = サンプリングせずに全顧客を対象にする）
            </div>
          </div>
        </div> -->
      </query-filter-element>
    </template>

    <!-- -------------------------------------------------------- -->
    <!-- 分析結果 -->
    <!-- -------------------------------------------------------- -->
    <template v-slot:result>
      <md-tabs
        :md-active-tab="activeResultTab"
        @md-changed="activeResultTab = $event"
      >
        <template slot="md-tab" slot-scope="{ tab }">
          <span
            :style="{
              textDecorationLine: tab.data.disabled
                ? 'line-through'
                : undefined,
            }"
          >
            {{ tab.label }}
          </span>
        </template>

        <md-tab id="leaf" md-label="顧客接点" ref="myMdTabs">
          <gl-table
            ref="itemTable"
            v-bind="resultTable.item"
            @initialized="setHeaderLinks"
          />
        </md-tab>
        <md-tab id="seg_f" md-label="目的範囲">
          <gl-table ref="segmentFTable" v-bind="resultTable.segmentF" />
        </md-tab>
        <md-tab id="seg_n" md-label="選択範囲">
          <gl-table ref="segmentNTable" v-bind="resultTable.segmentN" />
        </md-tab>
        <md-tab
          id="download"
          md-label="ダウンロード"
          :md-template-data="{ disabled: !$store.state.isQueryFullFeatured }"
        >
          <div v-if="!$store.state.isQueryFullFeatured">
            <p>
              {{ msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE }}
            </p>
          </div>
          <div v-else>
            <div>
              <a
                v-if="files.dendrogram.path"
                :href="files.dendrogram.path"
                target="_blank"
                rel="noopener noreferrer"
              >
                デンドログラム画像
              </a>
              <span v-else-if="files.dendrogram.noImageReason">{{
                files.dendrogram.noImageReason
              }}</span>
              <span v-else>ロード中…</span>
            </div>
            <div>
              <a
                v-if="files.distMatrix"
                :href="files.distMatrix"
                target="_blank"
                rel="noopener noreferrer"
              >
                距離行列表CSV
              </a>
              <span v-else>ロード中…</span>
            </div>
            <div>
              <a
                v-if="files.distMatrixSjis"
                :href="files.distMatrixSjis"
                target="_blank"
                rel="noopener noreferrer"
              >
                距離行列表CSV
                (S-JIS版。Excelなどで文字化けする場合はこちらをご利用ください。)
              </a>
              <span v-else>ロード中…</span>
            </div>
          </div>
        </md-tab>
        <md-tab
          id="leaf_detail"
          md-label="単品詳細"
          :md-template-data="{ disabled: !$store.state.isQueryFullFeatured }"
        >
          <div v-if="!$store.state.isQueryFullFeatured">
            <p>
              {{ msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE }}
            </p>
          </div>
          <div v-else>
            <div
              class="additional-table-explanation"
              :style="{
                height: resultTable.additionalExplanationHeightPx + 'px',
              }"
            >
              <span v-if="focusingItemCode.leafDetail === undefined">
                単品詳細を表示するには、表示したい顧客接点の「顧客接点 >
                単品数」をクリックしてください。
              </span>
              <span v-else>
                選択中の顧客接点：
                <span v-if="focusingItemCode.leafDetail === null">
                  マーケット計
                </span>
                <span v-else>
                  {{ focusingItemCode.leafDetail }}
                </span>
              </span>
              <div class="additional-table-explanation__tips">
                ※
                このタブがアクティブな場合、Excel出力では現在表示している単品詳細が
                <span class="additional-table-explanation__important-tips">
                  CSV
                </span>
                に出力されます。
              </div>
            </div>
            <gl-table
              v-show="existLeafDetailUrl"
              ref="leafDetailTable"
              v-bind="resultTable.leafDetail"
            />
          </div>
        </md-tab>
        <md-tab
          id="store_detail"
          md-label="店舗詳細"
          :md-template-data="{ disabled: !$store.state.isQueryFullFeatured }"
        >
          <div v-if="!$store.state.isQueryFullFeatured">
            <p>
              {{ msg.MSG_QUERY_FULL_FEATURE_UNAVAILABLE }}
            </p>
          </div>
          <div v-else>
            <div
              class="additional-table-explanation"
              :style="{
                height: resultTable.additionalExplanationHeightPx + 'px',
              }"
            >
              <span v-if="focusingItemCode.storeDetail === undefined">
                店舗詳細を表示するには、表示したい顧客接点の「販売状況 >
                店舗数」をクリックしてください。
              </span>
              <span v-else>
                選択中の顧客接点：
                <span v-if="focusingItemCode.storeDetail === null">
                  マーケット計
                </span>
                <span v-else>
                  {{ focusingItemCode.storeDetail }}
                </span>
              </span>
              <div class="additional-table-explanation__tips">
                ※
                ここに出力される店舗は分析条件で選択された店舗全てです。合計行の店舗数以上の店舗が出力されることがあります。
              </div>
              <div class="additional-table-explanation__tips">
                ※
                このタブがアクティブな場合、Excel出力では現在表示している店舗詳細が
                <span class="additional-table-explanation__important-tips">
                  CSV
                </span>
                に出力されます。
              </div>
            </div>
            <gl-table
              v-show="existStoreDetailUrl"
              ref="storeDetailTable"
              v-bind="resultTable.storeDetail"
            />
          </div>
        </md-tab>
      </md-tabs>

      <md-dialog
        :md-active.sync="editReport"
        :md-close-on-esc="true"
        :md-click-outside-to-close="true"
        style="width: 700px"
      >
        <md-dialog-content>
          <div style="display: flex; flex-direction: column;">
            <details
              class="report-edit-dialog-block"
              :open="reportEditDiologOpenState['additionalColumns']"
            >
              <summary class="report-edit-dialog-block__title">
                業務別追加表示項目
              </summary>
              <div>
                <md-field>
                  <md-select
                    v-model="reportEditParametersSnapshot.leaf.columns"
                    multiple
                  >
                    <md-option
                      v-for="c in _additionalColumns"
                      :key="c.id"
                      :value="c.id"
                      :disabled="c.hidden"
                    >
                      {{ c.label }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div>
                <a
                  href="#"
                  @click.prevent="resetColumnSelection(true)"
                  style="word-break: keep-all;"
                >
                  （{{
                    leafTypeLabels[queryFilter.leaf.type]
                  }}の初期設定に戻す）
                </a>
              </div>
            </details>

            <details
              class="report-edit-dialog-block"
              :open="reportEditDiologOpenState['adoptOrder']"
              :class="{
                'report-edit-dialog-block--highlight':
                  reportEditParameters.openSection === 'adoptOrder',
              }"
            >
              <summary class="report-edit-dialog-block__title">
                採用順算出ベース
              </summary>
              <div style="width: 200px">
                <md-field>
                  <md-select v-model="reportEditParametersSnapshot.adoptOrder">
                    <md-option
                      v-for="o in adoptOrders"
                      :key="o.id"
                      :value="o.id"
                      >{{ o.label }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>
            </details>

            <details
              class="report-edit-dialog-block"
              :open="reportEditDiologOpenState['orderAdjustment']"
              :class="{
                'report-edit-dialog-block--highlight':
                  reportEditParameters.openSection === 'orderAdjustment',
              }"
              v-if="
                reportEditParametersSnapshot.leaf.columns.some(t =>
                  [
                    'adoption',
                    'planogram',
                    'itemDistribution',
                    'spaceDistribution',
                  ].includes(t),
                )
              "
            >
              <summary class="report-edit-dialog-block__title">
                採用順降下と不採用（cut）
              </summary>

              <div>
                <md-checkbox
                  v-model="
                    reportEditParametersSnapshot.orderAdjustment
                      .optionsInSelection.selected
                  "
                >
                  1. 選択範囲（ニーズ）中の選択肢数
                </md-checkbox>
              </div>
              <div
                class="option-sub-box"
                v-if="
                  reportEditParametersSnapshot.orderAdjustment
                    .optionsInSelection.selected
                "
              >
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: var(--spacing-medium);">
                    選択範囲（ニーズ）中の選択肢数が最大
                  </div>
                  <div
                    class="input-inline"
                    style="margin-right: var(--spacing-medium);"
                  >
                    <md-field
                      class="input-inline__field input-inline__field--small"
                    >
                      <md-input
                        v-model.number="
                          reportEditParametersSnapshot.orderAdjustment
                            .optionsInSelection.value
                        "
                        type="number"
                        :min="1"
                        :step="1"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div>
                    となるよう採用順を調整する
                  </div>
                </div>
              </div>
              <div>
                <md-checkbox
                  v-model="
                    reportEditParametersSnapshot.orderAdjustment
                      .unnecessarySelection.selected
                  "
                >
                  2. 不要選択範囲（ニーズ）
                </md-checkbox>
              </div>
              <div
                class="option-sub-box"
                v-if="
                  reportEditParametersSnapshot.orderAdjustment
                    .unnecessarySelection.selected
                "
              >
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: var(--spacing-medium);">
                    利用者率
                  </div>
                  <div
                    class="input-inline"
                    style="margin-right: var(--spacing-medium);"
                  >
                    <md-field
                      class="input-inline__field input-inline__field--small"
                    >
                      <md-input
                        v-model.number="
                          reportEditParametersSnapshot.orderAdjustment
                            .unnecessarySelection.value
                        "
                        type="number"
                        :step="0.005"
                        :min="0"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div>
                    %未満の選択範囲（ニーズ）の選択肢の採用順を一律下げる
                  </div>
                </div>
              </div>
              <div
                v-if="
                  reportEditParametersSnapshot.orderAdjustment
                    .optionsInSelection.selected &&
                    reportEditParametersSnapshot.orderAdjustment
                      .unnecessarySelection.selected
                "
                style="display: flex; align-items: center;"
              >
                <div
                  style="word-break: keep-all; margin-right: var(--spacing-medium);"
                >
                  降下処理順序は
                </div>
                <div style="width: 300px">
                  <md-field>
                    <md-select
                      v-model="
                        reportEditParametersSnapshot.orderAdjustment.priority
                      "
                    >
                      <md-option value="optionsInSelection"
                        >1 → 2 の順</md-option
                      >
                      <md-option value="unnecessarySelection"
                        >2 → 1 の順</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
              </div>
              <div
                v-if="
                  reportEditParametersSnapshot.orderAdjustment
                    .optionsInSelection.selected ||
                    reportEditParametersSnapshot.orderAdjustment
                      .unnecessarySelection.selected
                "
                style="margin-top: var(--spacing-medium); display: flex;"
              >
                <div style="margin-right: var(--spacing-small);">
                  <md-icon>info</md-icon>
                </div>
                <div style="color: var(--color-secondary-text);">
                  <div>
                    この採用順降下条件に該当する選択肢の数は
                    <span style="font-weight: bold;">
                      <span
                        v-if="
                          reportEditParameters.isCalculatingCutCandidatesCount
                        "
                      >
                        計算中...
                      </span>
                      <span
                        v-else-if="
                          reportEditParameters.cutCandidatesCount !== null
                        "
                      >
                        {{ reportEditParameters.cutCandidatesCount }}（{{
                          candidatesCutRatio
                        }}％）
                      </span>
                      <span v-else style="color: var(--color-warn)">
                        エラーが発生しました
                      </span>
                    </span>
                    です
                  </div>
                  <div
                    v-if="reportEditParameters.cutCandidatesCount !== null"
                    style="display: flex; align-items: center;"
                  >
                    <div>
                      <a
                        href="#"
                        @click.prevent="
                          reportEditParametersSnapshot.cutCount =
                            reportEditParameters.cutCandidatesCount
                        "
                      >
                        これを不採用数にする
                      </a>
                    </div>
                    <div style="flex-shrink: 0;">
                      <md-icon
                        style="color: var(--md-theme-default-primary-on-background, #448aff); font-size: 16px !important"
                        >arrow_downward</md-icon
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <div style="margin-right: var(--spacing-medium);">
                  降下後の採用順降順で
                </div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="reportEditParametersSnapshot.cutCount"
                      type="number"
                      :step="1"
                      :min="0"
                      :max="leafTotalCount"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div>（{{ cutRatio }}％）を不採用</div>
              </div>
            </details>

            <details
              class="report-edit-dialog-block"
              :open="reportEditDiologOpenState['pattern']"
              :class="{
                'report-edit-dialog-block--highlight':
                  reportEditParameters.openSection === 'pattern',
              }"
              v-if="
                reportEditParametersSnapshot.leaf.columns.includes('planogram')
              "
            >
              <summary class="report-edit-dialog-block__title">
                棚割パターン割付
              </summary>

              <div style="display: flex; align-items: center;">
                <div style="margin-right: var(--spacing-medium);">
                  最大パターン本数
                </div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.maxPatternCount
                      "
                      type="number"
                      :step="1"
                      :min="1"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div>
                  本
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <div style="margin-right: var(--spacing-medium);">
                  表示単位文字列
                </div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field>
                    <md-input
                      v-model="reportEditParametersSnapshot.patternLabel"
                      type="text"
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <div style="margin-right: var(--spacing-medium);">
                  cut単品表示文字列
                </div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field>
                    <md-input
                      v-model="reportEditParametersSnapshot.cutLabel"
                      type="text"
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div>
                フェイシング数と補充サイクル
              </div>
              <div style="margin-left: var(--spacing-large)">
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: var(--spacing-medium);">
                    最大
                  </div>
                  <div
                    class="input-inline"
                    style="margin-right: var(--spacing-medium);"
                  >
                    <md-field
                      class="input-inline__field input-inline__field--small"
                    >
                      <md-input
                        v-model.number="reportEditParametersSnapshot.facingMax"
                        type="number"
                        :step="1"
                        :min="1"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div>
                    フェイシング
                  </div>
                </div>
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: var(--spacing-medium);">
                    最低
                  </div>
                  <div
                    class="input-inline"
                    style="margin-right: var(--spacing-medium);"
                  >
                    <md-field
                      class="input-inline__field input-inline__field--small"
                    >
                      <md-input
                        v-model.number="reportEditParametersSnapshot.facingMin"
                        type="number"
                        :step="1"
                        :min="1"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div>
                    フェイシング
                  </div>
                </div>
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: var(--spacing-medium);">
                    補充サイクル
                  </div>
                  <div
                    class="input-inline"
                    style="margin-right: var(--spacing-medium);"
                  >
                    <md-field
                      class="input-inline__field input-inline__field--small"
                    >
                      <md-input
                        v-model.number="
                          reportEditParametersSnapshot.restockCycleDays
                        "
                        type="number"
                        :step="1"
                        :min="1"
                        required
                      ></md-input>
                    </md-field>
                  </div>
                  <div>
                    日間
                  </div>
                </div>
              </div>
              <div>
                在庫係数
              </div>
              <div style="margin-left: var(--spacing-large)">
                <div style="width: 500px;">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: var(--spacing-x-small);
                    "
                  >
                    <div
                      style="margin-right: var(--spacing-medium); white-space: nowrap;"
                    >
                      全体
                    </div>
                    <div style="flex: 1; margin-right: var(--spacing-medium);">
                      <md-field style="width: 100%;">
                        <md-input
                          v-model.number="
                            reportEditParametersSnapshot.stockCoefficientAll
                          "
                          type="number"
                          :step="0.1"
                          :min="0"
                          required
                        ></md-input>
                      </md-field>
                    </div>
                    <div>
                      倍
                    </div>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: var(--spacing-x-small);
                    "
                  >
                    <div style="width: 50%; text-align: center;">
                      ×
                    </div>
                    <div style="width: 50%; text-align: center;">
                      ×
                    </div>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <div
                      style="
                        width: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <div style="margin-right: var(--spacing-medium);">
                        1stレコメンド
                      </div>
                      <div
                        class="input-inline"
                        style="margin-right: var(--spacing-medium);"
                      >
                        <md-field
                          class="input-inline__field input-inline__field--small"
                        >
                          <md-input
                            v-model.number="
                              reportEditParametersSnapshot.stockCoefficient1st
                            "
                            type="number"
                            :step="0.1"
                            :min="0"
                            required
                          ></md-input>
                        </md-field>
                      </div>
                      <div>
                        倍
                      </div>
                    </div>
                    <div
                      style="
                        width: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <div style="margin-right: var(--spacing-medium);">
                        2ndレコメンド
                      </div>
                      <div
                        class="input-inline"
                        style="margin-right: var(--spacing-medium);"
                      >
                        <md-field
                          class="input-inline__field input-inline__field--small"
                        >
                          <md-input
                            v-model.number="
                              reportEditParametersSnapshot.stockCoefficient2nd
                            "
                            type="number"
                            :step="0.1"
                            :min="0"
                            required
                          ></md-input>
                        </md-field>
                      </div>
                      <div>
                        倍
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </details>

            <details
              class="report-edit-dialog-block"
              :open="reportEditDiologOpenState['itemDistribution']"
              :class="{
                'report-edit-dialog-block--highlight':
                  reportEditParameters.openSection === 'itemDistribution',
              }"
              v-if="
                reportEditParametersSnapshot.leaf.columns.includes(
                  'itemDistribution',
                )
              "
            >
              <summary class="report-edit-dialog-block__title">
                販促単品分配
              </summary>

              <div>
                <div>
                  <gl-sub-text>【用途】</gl-sub-text>
                </div>
                <div>
                  <gl-sub-text>
                    主にチラシ掲載品等、限られた単品数を
                  </gl-sub-text>
                </div>
                <div>
                  <gl-sub-text>
                    どの顧客接点に何単品割り振るべきかシミュレーションします
                  </gl-sub-text>
                </div>
              </div>
              <div>
                <md-radio
                  v-model="reportEditParametersSnapshot.itemDistributionMode"
                  value="count"
                >
                  分配単品数で指定
                </md-radio>
                <md-radio
                  v-model="reportEditParametersSnapshot.itemDistributionMode"
                  value="range"
                >
                  上限・下限で指定
                </md-radio>
              </div>
              <div
                v-if="
                  reportEditParametersSnapshot.itemDistributionMode === 'count'
                "
                style="display: flex; align-items: center;"
              >
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.itemDistributionCount
                      "
                      type="number"
                      :step="1"
                      :min="0"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div>単品を分配する（分配単品数）</div>
              </div>
              <div v-else style="display: flex; align-items: center;">
                <div style="margin-right: var(--spacing-medium);">下限</div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.itemDistributionCountMin
                      "
                      type="number"
                      :step="1"
                      :min="1"
                      :max="
                        reportEditParametersSnapshot.itemDistributionCountMax
                      "
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div style="margin-right: var(--spacing-medium);">上限</div>
                <div class="input-inline">
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.itemDistributionCountMax
                      "
                      type="number"
                      :step="1"
                      :min="
                        reportEditParametersSnapshot.itemDistributionCountMin
                      "
                      required
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div style="display: flex; align-items: center;">
                <div>
                  重点レコメンドが
                </div>
                <div
                  class="input-inline"
                  style="margin-left: var(--spacing-medium); margin-right: var(--spacing-medium);"
                >
                  <md-field style="width: 180px;">
                    <md-select
                      v-model="
                        reportEditParametersSnapshot.recommendsToDistributeItemCount
                      "
                    >
                      <md-option value="1st">1stのみ</md-option>
                      <md-option value="1st,2nd">2nd以上</md-option>
                      <md-option value="1st,2nd,3rd">3rd以上</md-option>
                      <md-option value="all">
                        全て（空欄を含む）
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div>
                  の顧客接点で分配する
                </div>
              </div>
            </details>

            <details
              class="report-edit-dialog-block"
              :open="reportEditDiologOpenState['spaceDistribution']"
              :class="{
                'report-edit-dialog-block--highlight':
                  reportEditParameters.openSection === 'spaceDistribution',
              }"
              v-if="
                reportEditParametersSnapshot.leaf.columns.includes(
                  'spaceDistribution',
                )
              "
            >
              <summary class="report-edit-dialog-block__title">
                理論スペース分配
              </summary>

              <div>
                <div>
                  <gl-sub-text>与えられたスペースに関わる割当総数</gl-sub-text>
                </div>
                <div>
                  <gl-sub-text>
                    （コマ数／坪数／台数／段数／フェイシング数等）
                  </gl-sub-text>
                </div>
                <div>
                  <gl-sub-text>
                    を変更採用順=0（cut）を除き、スペース分配率で単純分配します
                  </gl-sub-text>
                </div>
              </div>
              <div>
                <md-radio
                  v-model="reportEditParametersSnapshot.spaceDistributionMode"
                  value="count"
                >
                  割当総数で指定
                </md-radio>
                <md-radio
                  v-model="reportEditParametersSnapshot.spaceDistributionMode"
                  value="range"
                >
                  上限・下限で指定
                </md-radio>
              </div>
              <div
                v-if="
                  reportEditParametersSnapshot.spaceDistributionMode === 'count'
                "
                style="display: flex; align-items: center;"
              >
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.spaceDistributionCount
                      "
                      type="number"
                      :step="1"
                      :min="0"
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div>を分配する（割当総数）</div>
              </div>
              <div v-else style="display: flex; align-items: center;">
                <div style="margin-right: var(--spacing-medium);">下限</div>
                <div
                  class="input-inline"
                  style="margin-right: var(--spacing-medium);"
                >
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.spaceDistributionCountMin
                      "
                      type="number"
                      :step="1"
                      :min="1"
                      :max="
                        reportEditParametersSnapshot.spaceDistributionCountMax
                      "
                      required
                    ></md-input>
                  </md-field>
                </div>
                <div style="margin-right: var(--spacing-medium);">上限</div>
                <div class="input-inline">
                  <md-field
                    class="input-inline__field input-inline__field--small"
                  >
                    <md-input
                      v-model.number="
                        reportEditParametersSnapshot.spaceDistributionCountMax
                      "
                      type="number"
                      :step="1"
                      :min="
                        reportEditParametersSnapshot.spaceDistributionCountMin
                      "
                      required
                    ></md-input>
                  </md-field>
                </div>
              </div>
            </details>
          </div>
        </md-dialog-content>

        <md-dialog-actions>
          <gl-button @click="editReport = false">閉じる</gl-button>
          <gl-button primary @click="applyReportEditDialogSnapshot">
            反映する
          </gl-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（ニーズ要約） -->
      <md-dialog
        :md-active.sync="experimentalAi.segmentDescription.isDialogOpen"
        :md-close-on-esc="!experimentalAi.segmentDescription.isAiGenerating"
        :md-click-outside-to-close="
          !experimentalAi.segmentDescription.isAiGenerating
        "
        style="width: 800px"
      >
        <md-dialog-content>
          <ai-feature-layout title="目的/選択範囲のニーズ要約">
            <p>
              目的範囲（f1, f2...）・選択範囲（f1_n1,
              f1_n2...）それぞれに自然言語によるニーズ要約を付与します！
            </p>
            <p>
              これにより、各目的範囲・選択範囲がどのような要素で構成されているか素早く把握することができます。
            </p>
            <p>
              現在この機能は、顧客接点が「単品」「店舗」「年月日」の何れかであり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>
            <p
              v-if="
                experimentalAi.segmentDescription.hasGenerated &&
                  !experimentalAi.segmentDescription.isAiGenerating
              "
              style="font-weight: bold;"
            >
              ニーズ要約が生成されました！<br />「表示結果に反映する」をONにすると分析結果に追加されます🎉
            </p>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <gl-button
            v-if="!experimentalAi.segmentDescription.isAiGenerating"
            @click="experimentalAi.segmentDescription.isDialogOpen = false"
            >閉じる</gl-button
          >
          <gl-switch
            v-if="experimentalAi.segmentDescription.hasGenerated"
            v-model="experimentalAi.segmentDescription.isVisibleInResult"
            :disabled="experimentalAi.segmentDescription.isAiGenerating"
            :gl-tooltip="
              experimentalAi.segmentDescription.isAiGenerating
                ? 'ニーズ要約を生成中は設定変更できません'
                : ''
            "
          >
            表示結果に反映する
          </gl-switch>
          <gl-button
            primary
            @click="generateSegmentDescription"
            :disabled="
              experimentalAi.segmentDescription.isAiGenerating ||
                !experimentalAi.segmentDescription.leafAllowed.includes(
                  experimentalAi.leafOfThisQuery,
                ) ||
                experimentalAi.leafCount > experimentalAi.maxLeafCount ||
                experimentalAi.isInInterval
            "
          >
            <span v-if="experimentalAi.segmentDescription.isAiGenerating">
              <spinner :diameter="10" :stroke="2" />
              ニーズ要約を生成中...
            </span>
            <span v-else-if="experimentalAi.isInInterval">
              再実行までしばらくお待ちください...
            </span>
            <span v-else>
              ニーズ要約を<span
                v-if="experimentalAi.segmentDescription.hasGenerated"
                >再</span
              >作成する
            </span>
          </gl-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（新商品提案） -->
      <md-dialog
        :md-active.sync="experimentalAi.newItemSuggestion.isDialogOpen"
        :md-close-on-esc="!experimentalAi.newItemSuggestion.isAiGenerating"
        :md-click-outside-to-close="
          !experimentalAi.newItemSuggestion.isAiGenerating
        "
        style="width: 1000px"
      >
        <md-dialog-content>
          <ai-feature-layout title="売り場に採用すべき新商品の推論">
            <p>
              現状の分析結果から、この売り場に採用すべき新商品を推論します！
            </p>
            <p>
              現在この機能は、顧客接点が「単品」であり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>

            <div class="button-group">
              <gl-button
                class="button-group__button"
                dense
                raised
                :disabled="
                  experimentalAi.newItemSuggestion.suggestions.length === 0
                "
                @click="
                  copyAiSuggestionToClipboard(
                    experimentalAi.newItemSuggestion.suggestions,
                    [
                      '期待値順位',
                      '新商品区分',
                      '商品コード',
                      '商品名',
                      '検討事項',
                    ],
                  )
                "
              >
                <span v-if="!experimentalAi.showClipboardCopiedMessage">
                  出力結果をクリップボードにコピーする
                </span>
                <span v-else>
                  ✅ クリップボードにコピーしました！
                </span>
              </gl-button>
              <gl-button
                class="button-group__button"
                dense
                :disabled="
                  experimentalAi.newItemSuggestion.suggestions.length === 0
                "
                @click="experimentalAi.newItemSuggestion.suggestions = []"
              >
                提案をクリアする
              </gl-button>
            </div>

            <div v-if="experimentalAi.newItemSuggestion.suggestions.length > 0">
              <md-table class="new-item-suggestion-table">
                <md-table-row>
                  <md-table-head class="cell" md-numeric
                    >期待値順位</md-table-head
                  >
                  <md-table-head class="cell">新商品区分</md-table-head>
                  <md-table-head class="cell">商品コード</md-table-head>
                  <md-table-head class="cell">商品名</md-table-head>
                  <md-table-head class="cell">検討事項</md-table-head>
                </md-table-row>
                <md-table-row
                  v-for="(suggestion, index) in experimentalAi.newItemSuggestion
                    .suggestions"
                  :key="`${index}-${suggestion['期待値順位']}`"
                >
                  <md-table-cell class="cell" md-numeric>{{
                    suggestion['期待値順位']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['新商品区分']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['商品コード']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['商品名']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['検討事項']
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <gl-button
            v-if="!experimentalAi.newItemSuggestion.isAiGenerating"
            @click="experimentalAi.newItemSuggestion.isDialogOpen = false"
            >閉じる</gl-button
          >
          <gl-button
            primary
            @click="generateNewItemSuggestion"
            :disabled="
              experimentalAi.newItemSuggestion.isAiGenerating ||
                !experimentalAi.newItemSuggestion.leafAllowed.includes(
                  experimentalAi.leafOfThisQuery,
                ) ||
                experimentalAi.leafCount > experimentalAi.maxLeafCount ||
                experimentalAi.isInInterval
            "
          >
            <span v-if="experimentalAi.newItemSuggestion.isAiGenerating">
              <spinner :diameter="10" :stroke="2" />
              提案を生成中...
            </span>
            <span v-else-if="experimentalAi.isInInterval">
              再実行までしばらくお待ちください...
            </span>
            <span v-else>
              新商品提案を作成する
            </span>
          </gl-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（新商品の陳列位置提案） -->
      <md-dialog
        :md-active.sync="experimentalAi.newItemPositionSuggestion.isDialogOpen"
        :md-close-on-esc="
          !experimentalAi.newItemPositionSuggestion.isAiGenerating
        "
        :md-click-outside-to-close="
          !experimentalAi.newItemPositionSuggestion.isAiGenerating
        "
        style="width: 1000px"
      >
        <md-dialog-content>
          <ai-feature-layout title="新商品の陳列位置の推論">
            <p>
              売り場に追加予定の新商品情報を以下のウィンドウに貼り付けて頂く事で、
              「選択範囲f1_n1内の関連順1と2の間」 のような陳列位置を推論します！
            </p>
            <p>
              商品コード、商品名、規格、単価、メーカーの貼付を推奨します。列見出しも一緒に貼り付けて頂いた方が、推論の精度が上がります。
            </p>
            <details style="margin-bottom: var(--spacing-small)">
              <summary style="color: var(--color-warn); cursor: pointer">
                貼付データ例（クリックで開きます）
              </summary>
              <p>
                いずれの項目も必須ではありません。この例ではコードを省略している商品も混在しています。
              </p>
              <p>
                区切り文字のカンマはタブでもOKです。Excelからコピー＆ペーストで貼り付けていただいても問題ありません。
              </p>
              <pre
                style="color: var(--color-secondary-text); border: 3px dotted var(--color-border); padding: var(--spacing-small)"
              >
コード,名称
, ポポロスパ5分
4942355199595, 冷凍ラザニア 400g
4902110380514, 日清 マ・マー 超もち生パスタ 濃厚海老トマトクリーム 275g
4902110380828, 日清 マ・マー 超もち生パスタ 濃厚明太子クリーム 270g
, 低糖質ソイパスタ 鶏むね肉とバジル 250g
, 冷凍タイ風グリーンカレーパスタ 300g
, オーマイ 大盛り 濃厚エビトマトクリーム 340g</pre
              >
            </details>
            <div>
              <textarea
                v-model="experimentalAi.newItemPositionSuggestion.newItemData"
                style="width: 100%; height: 150px"
                placeholder="ここに新商品情報を貼り付け"
              >
              </textarea>
            </div>
            <p>
              現在この機能は、顧客接点が「単品」であり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>

            <div class="button-group">
              <gl-button
                class="button-group__button"
                dense
                raised
                :disabled="
                  experimentalAi.newItemPositionSuggestion.suggestions
                    .length === 0
                "
                @click="
                  copyAiSuggestionToClipboard(
                    experimentalAi.newItemPositionSuggestion.suggestions,
                    [
                      ['コード', '商品コード'],
                      ['名称', '商品名'],
                      '追加／入れ替え',
                      '陳列位置',
                    ],
                  )
                "
              >
                <span v-if="!experimentalAi.showClipboardCopiedMessage">
                  出力結果をクリップボードにコピー
                </span>
                <span v-else>
                  ✅ クリップボードにコピーしました！
                </span>
              </gl-button>
              <gl-button
                class="button-group__button"
                dense
                :disabled="
                  experimentalAi.newItemPositionSuggestion.suggestions
                    .length === 0 &&
                    experimentalAi.newItemPositionSuggestion.newItemData
                      .length === 0
                "
                @click="
                  experimentalAi.newItemPositionSuggestion.suggestions = []
                  experimentalAi.newItemPositionSuggestion.newItemData = ''
                "
              >
                新商品情報と提案をクリアする
              </gl-button>
            </div>

            <div
              v-if="
                experimentalAi.newItemPositionSuggestion.suggestions.length > 0
              "
            >
              <md-table class="new-item-suggestion-table">
                <md-table-row>
                  <md-table-head class="cell">商品コード</md-table-head>
                  <md-table-head class="cell">商品名</md-table-head>
                  <md-table-head class="cell">追加／入れ替え</md-table-head>
                  <md-table-head class="cell">陳列位置</md-table-head>
                </md-table-row>
                <md-table-row
                  v-for="(suggestion, index) in experimentalAi
                    .newItemPositionSuggestion.suggestions"
                  :key="`${index}`"
                >
                  <md-table-cell class="cell">{{
                    suggestion['コード']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['名称']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['追加／入れ替え']
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{
                    suggestion['陳列位置']
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <gl-button
            v-if="!experimentalAi.newItemPositionSuggestion.isAiGenerating"
            @click="
              experimentalAi.newItemPositionSuggestion.isDialogOpen = false
            "
            >閉じる</gl-button
          >
          <gl-button
            primary
            @click="generateNewItemPositionSuggestion"
            :disabled="
              experimentalAi.newItemPositionSuggestion.isAiGenerating ||
                !experimentalAi.newItemPositionSuggestion.leafAllowed.includes(
                  experimentalAi.leafOfThisQuery,
                ) ||
                (!experimentalAi.newItemPositionSuggestion.newItemData ||
                  experimentalAi.newItemPositionSuggestion.newItemData
                    .length === 0) ||
                experimentalAi.leafCount > experimentalAi.maxLeafCount ||
                experimentalAi.isInInterval
            "
          >
            <span
              v-if="experimentalAi.newItemPositionSuggestion.isAiGenerating"
            >
              <spinner :diameter="10" :stroke="2" />
              提案を生成中...
            </span>
            <span v-else-if="experimentalAi.isInInterval">
              再実行までしばらくお待ちください...
            </span>
            <span v-else>
              新商品提案を作成する
            </span>
          </gl-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（カット候補商品のレコメンド） -->
      <md-dialog
        :md-active.sync="experimentalAi.cutCandidateRecommendation.isDialogOpen"
        :md-close-on-esc="
          !experimentalAi.cutCandidateRecommendation.isAiGenerating
        "
        :md-click-outside-to-close="
          !experimentalAi.cutCandidateRecommendation.isAiGenerating
        "
        style="width: 1200px"
      >
        <md-dialog-content>
          <ai-feature-layout title="カット候補商品のレコメンド">
            <p>
              現状の分析結果の中で、カットできる商品を推論します！<br />
              以下を基準に商品カットを検討してください。
            </p>
            <p>
              【安全策（トリミング）】最大選択肢数＝9の場合のカット候補<br />
              【最大絞り込み】最大選択肢数＝5の場合のカット候補まですべて
            </p>
            <ul
              style="font-size: var(--font-size-small); padding-left: var(--spacing-large);"
            >
              <li>
                最大選択肢数＝9（網掛け有）の場合のカット候補については、お客さまの選び難さにも繋がっている為、強くカットを推奨します。
              </li>
              <li>
                ニーズ中の選択肢数に基づく推論です。ニーズそのものの大きさや、商品の入れ替えについては考慮されません。
              </li>
            </ul>
            <p>
              現在この機能は、顧客接点が「単品」であり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>

            <div class="button-group">
              <gl-button
                class="button-group__button"
                dense
                raised
                :disabled="
                  experimentalAi.cutCandidateRecommendation.recommendations
                    .length === 0
                "
                @click="
                  copyAiSuggestionToClipboard(
                    experimentalAi.cutCandidateRecommendation.recommendations,
                    [
                      ['maxChoices', '最大選択肢数'],
                      ['cutPriority', 'カット優先順位'],
                      ['itemCode', '商品コード'],
                      ['itemName', '商品名'],
                      ['cumulativeRatio', '累計構成比(SKU数)'],
                    ],
                  )
                "
              >
                <span v-if="!experimentalAi.showClipboardCopiedMessage">
                  出力結果をクリップボードにコピーする
                </span>
                <span v-else>
                  ✅ クリップボードにコピーしました！
                </span>
              </gl-button>
              <gl-button
                class="button-group__button"
                dense
                :disabled="
                  experimentalAi.cutCandidateRecommendation.recommendations
                    .length === 0
                "
                @click="
                  experimentalAi.cutCandidateRecommendation.recommendations = []
                  experimentalAi.cutCandidateRecommendation.excludedItems = []
                "
              >
                提案をクリアする
              </gl-button>
              <gl-button
                class="button-group__button"
                dense
                :disabled="
                  experimentalAi.cutCandidateRecommendation.recommendations
                    .length === 0
                "
                @click="
                  experimentalAi.cutCandidateRecommendation.excludedItems = experimentalAi.cutCandidateRecommendation.recommendations.map(
                    rec => rec.rowNum,
                  )
                "
              >
                すべて選択
              </gl-button>
              <gl-button
                class="button-group__button"
                dense
                :disabled="
                  experimentalAi.cutCandidateRecommendation.excludedItems
                    .length === 0
                "
                @click="
                  experimentalAi.cutCandidateRecommendation.excludedItems = []
                "
              >
                すべて解除
              </gl-button>
            </div>

            <div
              v-if="
                experimentalAi.cutCandidateRecommendation.recommendations
                  .length > 0
              "
            >
              <md-table class="new-item-suggestion-table">
                <md-table-row>
                  <md-table-head class="cell" md-numeric
                    >最大選択肢数</md-table-head
                  >
                  <md-table-head class="cell">不採用</md-table-head>
                  <md-table-head class="cell" md-numeric
                    >カット優先順位</md-table-head
                  >
                  <md-table-head class="cell">商品コード</md-table-head>
                  <md-table-head class="cell">商品名</md-table-head>
                  <md-table-head class="cell" md-numeric
                    >累計構成比(SKU数)</md-table-head
                  >
                </md-table-row>
                <md-table-row
                  v-for="rec in experimentalAi.cutCandidateRecommendation
                    .recommendations"
                  :key="rec.rowNum"
                  :style="
                    rec.maxChoices === 9 ? { backgroundColor: '#ffebee' } : {}
                  "
                >
                  <md-table-cell class="cell" md-numeric>{{
                    rec.maxChoices
                  }}</md-table-cell>
                  <md-table-cell class="cell">
                    <md-checkbox
                      v-model="
                        experimentalAi.cutCandidateRecommendation.excludedItems
                      "
                      :value="rec.rowNum"
                    />
                  </md-table-cell>
                  <md-table-cell class="cell" md-numeric>{{
                    rec.cutPriority
                  }}</md-table-cell>
                  <md-table-cell class="cell">{{ rec.itemCode }}</md-table-cell>
                  <md-table-cell class="cell">{{ rec.itemName }}</md-table-cell>
                  <md-table-cell class="cell" md-numeric>{{
                    rec.cumulativeRatio
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <gl-button
            v-if="!experimentalAi.cutCandidateRecommendation.isAiGenerating"
            @click="
              experimentalAi.cutCandidateRecommendation.isDialogOpen = false
            "
            >閉じる</gl-button
          >
          <gl-button
            raised
            :disabled="
              experimentalAi.cutCandidateRecommendation.isAiGenerating ||
                experimentalAi.cutCandidateRecommendation.excludedItems
                  .length === 0
            "
            @click="applyCutCandidateRecommendationToManualCut"
          >
            チェックしたものを不採用に反映
          </gl-button>
          <gl-button
            primary
            @click="generateCutCandidateRecommendation"
            :disabled="
              experimentalAi.cutCandidateRecommendation.isAiGenerating ||
                !experimentalAi.cutCandidateRecommendation.leafAllowed.includes(
                  experimentalAi.leafOfThisQuery,
                ) ||
                experimentalAi.leafCount > experimentalAi.maxLeafCount ||
                experimentalAi.isInInterval
            "
          >
            <span
              v-if="experimentalAi.cutCandidateRecommendation.isAiGenerating"
            >
              <spinner :diameter="10" :stroke="2" />
              レコメンドを生成中...
            </span>
            <span v-else-if="experimentalAi.isInInterval">
              再実行までしばらくお待ちください...
            </span>
            <span v-else>
              カット候補商品を推論する
            </span>
          </gl-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（重点商品実績なし店舗一覧出力） -->
      <md-dialog
        :md-active.sync="experimentalAi.recommendNonSalesStores.isDialogOpen"
        :md-close-on-esc="
          !experimentalAi.recommendNonSalesStores.isAiGenerating
        "
        :md-click-outside-to-close="
          !experimentalAi.recommendNonSalesStores.isAiGenerating
        "
        style="width: 800px"
      >
        <md-dialog-content>
          <ai-feature-layout title="重点商品実績なし店舗一覧出力">
            <p>
              重点レコメンド（1st,
              2ndレコメンド）商品の売上実績が立っていない店舗一覧を出力します
            </p>
            <p>
              <md-checkbox
                v-model="
                  experimentalAi.recommendNonSalesStores.includeThirdRecommend
                "
              >
                3rdレコメンドを出力対象に含める（大量に出力される場合があります）
              </md-checkbox>
            </p>
            <p>
              現在この機能は、顧客接点が「単品」であり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>
            <div
              v-if="
                experimentalAi.recommendNonSalesStores.downloadUrls.length > 0
              "
              class="recommend-non-sales-stores-download-links"
              style="padding: var(--spacing-small)"
            >
              <div
                v-for="(url, i) in experimentalAi.recommendNonSalesStores
                  .downloadUrls"
                :key="url"
              >
                <a :href="url" target="_blank" rel="noopener noreferrer">
                  ダウンロード
                  <span
                    v-if="
                      experimentalAi.recommendNonSalesStores.downloadUrls
                        .length > 1
                    "
                    >{{ i + 1 }}</span
                  >
                </a>
              </div>
            </div>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <gl-button
            v-if="!experimentalAi.recommendNonSalesStores.isAiGenerating"
            @click="experimentalAi.recommendNonSalesStores.isDialogOpen = false"
            >閉じる</gl-button
          >
          <gl-button
            primary
            @click="generateRecommendNonSalesStoresDownloadLink"
            :disabled="
              experimentalAi.recommendNonSalesStores.isAiGenerating ||
                !experimentalAi.recommendNonSalesStores.leafAllowed.includes(
                  experimentalAi.leafOfThisQuery,
                ) ||
                experimentalAi.leafCount > experimentalAi.maxLeafCount ||
                experimentalAi.isInInterval
            "
          >
            <span v-if="experimentalAi.recommendNonSalesStores.isAiGenerating">
              <spinner :diameter="10" :stroke="2" />
              一覧データを生成中...
            </span>
            <span v-else-if="experimentalAi.isInInterval">
              再実行までしばらくお待ちください...
            </span>
            <span v-else>
              店舗一覧を出力する
            </span>
          </gl-button>
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（棚割ソフト色分用ファイル出力） -->
      <md-dialog
        :md-active.sync="
          experimentalAi.planogramSoftwareColoringFile.isDialogOpen
        "
        :md-close-on-esc="
          !experimentalAi.planogramSoftwareColoringFile.isAiGenerating
        "
        :md-click-outside-to-close="
          !experimentalAi.planogramSoftwareColoringFile.isAiGenerating
        "
        style="width: 800px"
      >
        <md-dialog-content>
          <ai-feature-layout title="棚割ソフト色分用ファイル出力">
            <p>
              棚割ソフトで商品の色分けなどにご利用いただける「商品コード,親コード」形式のCSVファイルを生成・出力します
            </p>
            <p>
              現在この機能は、顧客接点が「単品」であり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>
            <div>
              <h4>基本</h4>
              <p>
                <a
                  href="#"
                  @click.prevent="downloadPlanogramColoringFile('seg_f_name')"
                  :class="{
                    'disabled-link':
                      experimentalAi.planogramSoftwareColoringFile
                        .isAiGenerating,
                  }"
                >
                  目的範囲色分用
                </a>
                <span v-if="experimentalAi.segmentDescription.hasGenerated">
                  /
                  <a
                    href="#"
                    @click.prevent="downloadPlanogramColoringFile('seg_f_desc')"
                    :class="{
                      'disabled-link':
                        experimentalAi.planogramSoftwareColoringFile
                          .isAiGenerating,
                    }"
                  >
                    目的範囲色分用（要約名で出力）
                  </a>
                </span>
              </p>
              <p>
                <a
                  href="#"
                  @click.prevent="downloadPlanogramColoringFile('seg_n_name')"
                  :class="{
                    'disabled-link':
                      experimentalAi.planogramSoftwareColoringFile
                        .isAiGenerating,
                  }"
                >
                  選択範囲色分用
                </a>
                <span v-if="experimentalAi.segmentDescription.hasGenerated">
                  /
                  <a
                    href="#"
                    @click="downloadPlanogramColoringFile('seg_n_desc')"
                    :class="{
                      'disabled-link':
                        experimentalAi.planogramSoftwareColoringFile
                          .isAiGenerating,
                    }"
                  >
                    選択範囲色分用（要約名で出力）
                  </a>
                </span>
              </p>
              <p>
                <a
                  href="#"
                  @click.prevent="downloadPlanogramColoringFile('recommend')"
                  :class="{
                    'disabled-link':
                      experimentalAi.planogramSoftwareColoringFile
                        .isAiGenerating,
                  }"
                >
                  重点レコメンド色分用
                </a>
              </p>

              <h4>棚割パターン割付</h4>
              <p>
                <a
                  href="#"
                  @click.prevent="downloadPlanogramColoringFile('pattern')"
                  :class="{
                    'disabled-link':
                      experimentalAi.planogramSoftwareColoringFile
                        .isAiGenerating,
                  }"
                >
                  カット／棚割パターン色分用
                </a>
              </p>
              <p>
                <a
                  href="#"
                  @click.prevent="downloadPlanogramColoringFile('facing')"
                  :class="{
                    'disabled-link':
                      experimentalAi.planogramSoftwareColoringFile
                        .isAiGenerating,
                  }"
                >
                  フェイシング数色分用
                </a>
              </p>
            </div>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <span
            v-if="experimentalAi.planogramSoftwareColoringFile.isAiGenerating"
          >
            <spinner :diameter="10" :stroke="2" />
            データを生成中...
          </span>
          <gl-button
            v-if="!experimentalAi.planogramSoftwareColoringFile.isAiGenerating"
            @click="
              experimentalAi.planogramSoftwareColoringFile.isDialogOpen = false
            "
            >閉じる</gl-button
          >
        </md-dialog-actions>
      </md-dialog>

      <!-- AI機能（クーポンターゲット顧客出力） -->
      <md-dialog
        :md-active.sync="experimentalAi.couponTargetCustomerFile.isDialogOpen"
        :md-close-on-esc="
          !experimentalAi.couponTargetCustomerFile.isAiGenerating
        "
        :md-click-outside-to-close="
          !experimentalAi.couponTargetCustomerFile.isAiGenerating
        "
        style="width: 800px"
      >
        <md-dialog-content>
          <ai-feature-layout title="クーポンターゲット顧客出力">
            <p>
              クーポン対象の商品コードを入力する事で、予算に応じたターゲット顧客を抽出します（複数可）
            </p>
            <p>
              現在この機能は、顧客接点が「単品」であり、分析結果の顧客接点数が{{
                experimentalAi.maxLeafCount
              }}以下の場合のみ有効です。
            </p>
            <div>
              <textarea
                v-model="experimentalAi.couponTargetCustomerFile.itemCodesInput"
                style="width: 100%; height: 120px"
                placeholder="商品コードを改行区切りで入力してください"
              >
              </textarea>
            </div>
            <div class="button-group">
              <gl-button
                class="button-group__button"
                dense
                raised
                @click="copyAiSuggestionToClipboard(existingItemCodesText)"
                :disabled="
                  !experimentalAi.couponTargetCustomerFile.hasGenerated
                "
              >
                <span v-if="!experimentalAi.showClipboardCopiedMessage">
                  読取り結果をクリップボードにコピーする
                </span>
                <span v-else>
                  ✅ クリップボードにコピーしました！
                </span>
              </gl-button>
              <gl-button
                class="button-group__button"
                dense
                :disabled="
                  !experimentalAi.couponTargetCustomerFile.hasGenerated
                "
                @click="
                  experimentalAi.couponTargetCustomerFile.hasGenerated = false
                  experimentalAi.couponTargetCustomerFile.itemCodesInput = ''
                "
              >
                入力商品一覧と出力結果をクリアする
              </gl-button>
            </div>
            <div
              v-if="experimentalAi.couponTargetCustomerFile.hasGenerated"
              class="coupon-target-customer-links"
              style="padding: var(--spacing-medium)"
            >
              <div style="display: flex; align-items: center;">
                <div>
                  読取り結果
                </div>
              </div>
              <div>
                <textarea
                  :value="existingItemCodesText"
                  style="width: 100%; height: 120px; color: grey;"
                  readonly
                  placeholder="読取り結果がここに表示されます"
                >
                </textarea>
              </div>
              <div>
                入力された
                <span style="font-weight: bold;">{{
                  experimentalAi.couponTargetCustomerFile.existingItemCodes
                    .length
                }}</span>
                商品中、
                <span style="font-weight: bold;">{{
                  experimentalAi.couponTargetCustomerFile.existingItemCodes.filter(
                    e => e.exists,
                  ).length
                }}</span>
                商品が分析結果に含まれています
              </div>
              <div>（分析結果の総商品数: {{ experimentalAi.leafCount }}）</div>
              <div>
                <md-checkbox
                  v-model="
                    experimentalAi.couponTargetCustomerFile
                      .showNotExistingItemCodes
                  "
                >
                  分析結果に含まれない商品も読取り結果に表示する
                </md-checkbox>
              </div>
              <p>
                ターゲット人数が多いほどヒット率は低くなります。以下のリンククリックで顧客一覧をダウンロード
              </p>
              <div>
                <div style="display: flex;">
                  <div style="width: 160px">目的範囲利用者（上限）</div>
                  <div>
                    ：
                    <a
                      href="#"
                      @click.prevent="downloadCouponTargetCustomerFile('seg_f')"
                      style="font-weight: bold;"
                      :class="{
                        'disabled-link':
                          experimentalAi.couponTargetCustomerFile
                            .isAiGenerating,
                      }"
                      gl-tooltip='指定商品が属する "目的範囲" の利用者'
                    >
                      {{
                        experimentalAi.couponTargetCustomerFile
                          .customerCountSegF
                      }}
                    </a>
                    人
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="width: 160px">選択範囲利用者</div>
                  <div>
                    ：
                    <a
                      href="#"
                      @click.prevent="downloadCouponTargetCustomerFile('seg_n')"
                      style="font-weight: bold;"
                      :class="{
                        'disabled-link':
                          experimentalAi.couponTargetCustomerFile
                            .isAiGenerating,
                      }"
                      gl-tooltip='指定商品が属する "選択範囲" の利用者'
                    >
                      {{
                        experimentalAi.couponTargetCustomerFile
                          .customerCountSegN
                      }}
                    </a>
                    人
                  </div>
                </div>
                <div style="display: flex;">
                  <div style="width: 160px">単品利用者（下限）</div>
                  <div>
                    ：
                    <a
                      href="#"
                      @click.prevent="downloadCouponTargetCustomerFile('leaf')"
                      style="font-weight: bold;"
                      :class="{
                        'disabled-link':
                          experimentalAi.couponTargetCustomerFile
                            .isAiGenerating,
                      }"
                      gl-tooltip="指定商品の利用者"
                    >
                      {{
                        experimentalAi.couponTargetCustomerFile
                          .customerCountLeaf
                      }}
                    </a>
                    人
                  </div>
                </div>
              </div>
            </div>
          </ai-feature-layout>
        </md-dialog-content>
        <md-dialog-actions>
          <gl-button
            v-if="!experimentalAi.couponTargetCustomerFile.isAiGenerating"
            @click="
              experimentalAi.couponTargetCustomerFile.isDialogOpen = false
            "
            >閉じる</gl-button
          >
          <gl-button
            primary
            @click="generateCouponTargetCustomer"
            :disabled="
              experimentalAi.couponTargetCustomerFile.isAiGenerating ||
                !experimentalAi.couponTargetCustomerFile.leafAllowed.includes(
                  experimentalAi.leafOfThisQuery,
                ) ||
                experimentalAi.leafCount > experimentalAi.maxLeafCount ||
                experimentalAi.isInInterval ||
                !experimentalAi.couponTargetCustomerFile.itemCodesInput
            "
          >
            <span v-if="experimentalAi.couponTargetCustomerFile.isAiGenerating">
              <spinner :diameter="10" :stroke="2" />
              一覧データを生成中...
            </span>
            <span v-else-if="experimentalAi.isInInterval">
              再実行までしばらくお待ちください...
            </span>
            <span v-else>
              顧客一覧を出力する
            </span>
          </gl-button>
        </md-dialog-actions>
      </md-dialog>
    </template>
  </long-query-layout>
</template>

<script>
// 分析条件, 分析結果のためのレイアウト
import LongQueryLayout from '@/components/layout/LongQueryLayout.vue'
// 分析条件
import QueryFilterElement from '@/components/QueryFilterElement.vue'
import FilterTerm from '@/components/FilterTermWithLimit.vue'
import FilterItem from '@/components/FilterItem.vue'
import FilterItemCategory from '@/components/FilterItemCategory.vue'
import FilterCategory from '@/components/FilterCategory.vue'
import FilterStore from '@/components/FilterStore.vue'
// 分析条件モデル
import term from '@/queryfilter/term'
import item from '@/queryfilter/item'
import category from '@/queryfilter/category'
import store from '@/queryfilter/store'
// 分析結果
import GlTable from '@/components/GlTable.vue'
// misc
import DialogConfirmation from '@/components/DialogConfirmation.vue'
import DialogWarning from '@/components/DialogWarning.vue'
import Spinner from '@/components/Spinner.vue'
import msg from '@/const/messages'
import AiFeatureLayout from '@/components/layout/AiFeatureLayout.vue'

import { searchCellCustomFunction } from '@/util/custom_formatters'
import { sleep } from '@/util/time'
import download from '@/util/download'

import repository from '@/repositories/Repository'
import {
  LEAF_TYPES,
  LEAF_TYPES_ORDERED,
  LEAF_TYPE_LABELS,
  ADDITIONAL_COLUMNS,
  ADDITIONAL_COLUMNS_ORDERED,
  ADOPT_ORDER,
  ADOPT_ORDER_LABELS,
  ADOPT_ORDER_ORDERED,
} from '@/const/shin-tapir'

import { Subject } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators'

let sizeFixed = false

let hold = false

// 全列共通セル背景色・文字色フォーマッター
function attributes(rowData, cell, value, colName) {
  const bgColors = rowData.attributes ? rowData.attributes.bgColor : {}
  const bgColor = bgColors ? bgColors[colName] : undefined
  if (bgColor) {
    cell.style.backgroundColor = bgColor
  }

  const fgColors = rowData.attributes ? rowData.attributes.fgColor : {}
  const fgColor = fgColors ? fgColors[colName] : undefined
  if (fgColor) {
    cell.style.color = fgColor
  }
}

// テーブルの列表示非表示設定
// tableType = 'leaf' | 'segF' | 'segN'
// additinalColumns = 選択されている業務別追加表示項目のArray
function setVisibleColumns(
  tableType,
  colModelsRef,
  additionalColumns,
  isDetail,
  isSegmentDescriptionVisible,
) {
  const visibleColumns = new Set()
  const visibleColumnRegex = new Set()

  const addToVisibleColumn = v => {
    if (v instanceof RegExp) {
      visibleColumnRegex.add(v)
    } else {
      visibleColumns.add(v)
    }
  }

  // 業務別追加表示項目の選択に依らず表示させる項目

  for (const col of VISIBLE_COLUMNS[tableType].base.alwaysVisible) {
    addToVisibleColumn(col)
  }
  if (isDetail) {
    for (const col of VISIBLE_COLUMNS[tableType].base.onlyDetail) {
      addToVisibleColumn(col)
    }
  }
  if (isSegmentDescriptionVisible) {
    for (const col of VISIBLE_COLUMNS[tableType].base
      .onlyExperimentalAiEnabled || []) {
      addToVisibleColumn(col)
    }
  }

  // 業務別追加表示項目の選択（任意複数）に応じて表示させる項目

  for (const add of additionalColumns) {
    if (!VISIBLE_COLUMNS[tableType][add]) {
      // このテーブル（leaf? segF? segN?）のこの業務別追加表示項目には追加表示設定なし
      continue
    }

    for (const col of VISIBLE_COLUMNS[tableType][add].alwaysVisible) {
      addToVisibleColumn(col)
    }
    if (isDetail) {
      for (const col of VISIBLE_COLUMNS[tableType][add].onlyDetail) {
        addToVisibleColumn(col)
      }
    }
  }

  for (const c of colModelsRef) {
    if (visibleColumns.has(c.colName)) {
      c.hidden = false
      continue
    }

    if (visibleColumnRegex.size === 0) {
      c.hidden = true
      continue
    }

    // additional regex matching
    for (const r of visibleColumnRegex) {
      if (r.test(c.colName)) {
        c.hidden = false
        break
      }
      c.hidden = true
    }
  }
}

// 業務別追加表示項目毎の表示列
const VISIBLE_COLUMNS = {
  segF: {
    base: {
      alwaysVisible: [
        'row_num',
        'seg_f_name',
        'customer_count',
        'customer_ratio',
        /^customer_count_ratio_\w+$/,
      ],
      onlyDetail: [],
      onlyExperimentalAiEnabled: ['seg_f_desc'],
    },
    [ADDITIONAL_COLUMNS.itemSelection]: {
      alwaysVisible: [
        'item_count',
        'leaf_count',
        'customer_magnification',
        'qty_per_receipt',
        'amount_per_qty',
        'customer_count_per_item_count',
        'customer_count_per_leaf_count',
        'amount_per_item_count',
        'amount_per_leaf_count',
      ],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.promotion]: {
      alwaysVisible: [],
      onlyDetail: ['r_customer_count', 't_customer_count', 'r_customer_ratio'],
    },
    [ADDITIONAL_COLUMNS.itemDistribution]: {
      alwaysVisible: ['item_distribution_count'],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.spaceDistribution]: {
      alwaysVisible: ['space_distribution_count'],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.others]: {
      alwaysVisible: ['amount', 'qty', 'receipt_count'],
      onlyDetail: [],
    },
  },
  segN: {
    base: {
      alwaysVisible: [
        'row_num',
        'seg_f_name',
        'seg_n_name',
        'customer_count',
        'customer_ratio',
        /^customer_count_ratio_\w+$/,
      ],
      onlyDetail: [],
      onlyExperimentalAiEnabled: ['seg_f_desc', 'seg_n_desc'],
    },
    [ADDITIONAL_COLUMNS.itemSelection]: {
      alwaysVisible: [
        'item_count',
        'leaf_count',
        'customer_magnification',
        'qty_per_receipt',
        'amount_per_qty',
        'customer_count_per_item_count',
        'customer_count_per_leaf_count',
        'amount_per_item_count',
        'amount_per_leaf_count',
      ],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.promotion]: {
      alwaysVisible: [],
      onlyDetail: ['r_customer_count', 't_customer_count', 'r_customer_ratio'],
    },
    [ADDITIONAL_COLUMNS.itemDistribution]: {
      alwaysVisible: ['item_distribution_count'],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.spaceDistribution]: {
      alwaysVisible: ['space_distribution_count'],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.others]: {
      alwaysVisible: ['amount', 'qty', 'receipt_count'],
      onlyDetail: [],
    },
  },
  leaf: {
    base: {
      alwaysVisible: [
        'row_num',
        'seg_f_name',
        'seg_n_name',
        'row_num2',
        'item_code',
        'item_name',
        'adopt_order',
        'recommend',
        'item_customer_count',
        'item_customer_ratio',
        'used_rate_weighted_average',
        'store_amount',
      ],
      onlyDetail: ['store_qty', 'store_receipt_count'],
      onlyExperimentalAiEnabled: ['seg_f_desc', 'seg_n_desc'],
    },
    [ADDITIONAL_COLUMNS.itemSelection]: {
      alwaysVisible: [
        'item_item_count',
        'item_customer_magnification',
        'item_qty_per_receipt',
        'item_amount_per_qty',
        'store_count',
      ],
      onlyDetail: ['ymd_from', 'ymd_to', 'average_sales_period'],
    },
    [ADDITIONAL_COLUMNS.promotion]: {
      alwaysVisible: [
        'seg_f_customer_count',
        'seg_f_customer_ratio',
        'seg_n_customer_count',
        'seg_n_customer_ratio',
      ],
      onlyDetail: [
        'seg_f_r_customer_count',
        'seg_f_t_customer_count',
        'seg_f_r_customer_ratio',
        'seg_n_r_customer_count',
        'seg_n_t_customer_count',
        'seg_n_r_customer_ratio',
        'item_r_customer_count',
        'item_t_customer_count',
        'item_r_customer_ratio',
      ],
    },
    [ADDITIONAL_COLUMNS.adoption]: {
      alwaysVisible: ['order_adjusted'],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.planogram]: {
      alwaysVisible: [
        'order_adjusted',
        'facing',
        'pattern',
        'depth_count',
        'display_count_sum',
      ],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.itemDistribution]: {
      alwaysVisible: [
        'item_distribution_ratio',
        'item_distribution_count',
        'item_distribution_count_ceil',
      ],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.spaceDistribution]: {
      alwaysVisible: [
        'space_distribution_ratio',
        'space_distribution_count',
        'space_distribution_count_ceil',
      ],
      onlyDetail: [],
    },
    [ADDITIONAL_COLUMNS.others]: {
      alwaysVisible: [
        'item_amount',
        'item_qty',
        'item_receipt_count',
        'total_amount',
        'total_qty',
        ...[...Array(10)].map(
          (_, i) => `category${i.toString().padStart(2, '0')}_code`,
        ),
        ...[...Array(10)].map(
          (_, i) => `category${i.toString().padStart(2, '0')}_name`,
        ),
      ],
      onlyDetail: [],
    },
  },
}

// 業務別追加表示項目プリセット
const ADDITIONAL_COLUMNS_PRESETS = {
  [LEAF_TYPES.item]: {
    hidden: [ADDITIONAL_COLUMNS.itemDistribution],
    selected: [
      ADDITIONAL_COLUMNS.itemSelection,
      ADDITIONAL_COLUMNS.adoption,
      ADDITIONAL_COLUMNS.planogram,
    ],
  },
  [LEAF_TYPES.itemCategory]: {
    hidden: [ADDITIONAL_COLUMNS.planogram],
    selected: [
      ADDITIONAL_COLUMNS.itemSelection,
      ADDITIONAL_COLUMNS.itemDistribution,
    ],
  },
  [LEAF_TYPES.store]: {
    hidden: [ADDITIONAL_COLUMNS.planogram],
    selected: [],
  },
  [LEAF_TYPES.ymd]: {
    hidden: [
      ADDITIONAL_COLUMNS.planogram,
      ADDITIONAL_COLUMNS.spaceDistribution,
    ],
    selected: [],
  },
  [LEAF_TYPES.day]: {
    hidden: [
      ADDITIONAL_COLUMNS.planogram,
      ADDITIONAL_COLUMNS.spaceDistribution,
    ],
    selected: [],
  },
  [LEAF_TYPES.time]: {
    hidden: [
      ADDITIONAL_COLUMNS.planogram,
      ADDITIONAL_COLUMNS.spaceDistribution,
    ],
    selected: [],
  },
  [LEAF_TYPES.priceLine]: {
    hidden: [ADDITIONAL_COLUMNS.planogram],
    selected: [ADDITIONAL_COLUMNS.itemSelection],
  },
  [LEAF_TYPES.posNumber]: {
    hidden: [ADDITIONAL_COLUMNS.planogram],
    selected: [],
  },
}

const MAX_MANUAL_CUT_TOGGLE_COUNT = 100

function getPresetSelection() {
  return Object.entries(ADDITIONAL_COLUMNS_PRESETS).reduce(
    (acc, [key, value]) => {
      acc[key] = value.selected
      return acc
    },
    {},
  )
}

export default {
  components: {
    QueryFilterElement,
    FilterTerm,
    FilterItem,
    FilterCategory,
    FilterItemCategory,
    // FilterCategoryItemCategory,
    FilterStore,
    // FilterOption,
    LongQueryLayout,
    GlTable,
    AiFeatureLayout,
    Spinner,
  },
  data() {
    return {
      /**
       * 表示タブ（分析条件、分析結果）
       */
      activeTab: undefined,
      msg,

      resourceName: 'shin-tapir',
      /**
       * 結果表示タブ
       */
      activeResultTab: undefined,
      /**
       * 現在表示しているクエリID
       */
      queryId: undefined,
      leafTypes: LEAF_TYPES,
      leafTypesOrdered: LEAF_TYPES_ORDERED,
      leafTypeLabels: LEAF_TYPE_LABELS,
      columns: ADDITIONAL_COLUMNS_ORDERED,
      adoptOrders: ADOPT_ORDER_ORDERED,
      // 分析結果のリーフ数
      leafTotalCount: 0,
      /**
       * 分析条件
       */
      queryFilter: {
        leaf: {
          order: 1,
          type: LEAF_TYPES.item,
          minCustomerCount: 1,
          // 顧客接点毎の選択追加項目を全て保存したいので常に全てのタイプの選択値を保持します
          columns: getPresetSelection(),
          summaryKey: 'shinTapirLeaf',
        },
        term: { order: 2, ...term.get() },
        // マーケット構成単品/分類
        marketItems: {
          // 顧客接点＝単品 用
          item: { ...item.get() },
          // 顧客接点＝分類 用
          category: {
            ...category.get(),
          },
          isLeafCategory: false,
          errors: [],
          order: 3,
          summaryKey: 'itemShinTapir',
        },
        store: { order: 4, ...store.get() },
        option: {
          order: 5,
          adoptOrder: ADOPT_ORDER.customerCount,
          orderAdjustment: {
            optionsInSelection: {
              selected: false,
              value: 9,
            },
            unnecessarySelection: {
              selected: false,
              value: 0.01,
            },
            priority: 'optionsInSelection',
            cutWhenApplicable: true,
          },
          r: 2,
          priceLine: 1,
          minuteStep: 10,
          facingMin: 1,
          facingMax: 5,
          restockCycleDays: 7,
          // 在庫係数
          stockCoefficientAll: 1.0,
          stockCoefficient1st: 1.4,
          stockCoefficient2nd: 1.2,
          // TODO 最終的には不要（シンKappaの距離算出ロジックを使う）
          usePotentiallyDangerousShinKappaDistCalc: false,
          shinKappaCustomerSamplingMax: 16641,
          summaryKey: 'shinTapirOption',
        },
      },
      // 分析条件にはないが、顧客接点追加パラメーター設定ダイアログで分析後に任意で変更できるパラメーター
      reportEditParameters: {
        // 不採用
        cutCount: 0,
        // 棚割パターン割付
        maxPatternCount: 1,
        patternLabel: '本パターン以上',
        cutLabel: 'cut',
        // 販促単品分配
        itemDistributionMode: 'count',
        itemDistributionCount: 0,
        itemDistributionCountMin: 1,
        itemDistributionCountMax: 1,
        recommendsToDistributeItemCount: 'all', // Note: 何か値を入れないと選択されなかった...?
        // 理論スペース分配
        spaceDistributionMode: 'count',
        spaceDistributionCount: 0,
        spaceDistributionCountMin: 1,
        spaceDistributionCountMax: 1,
        // ダイアログ上で開いているセクション名（指定なしの場合は全て開いていると判断します）
        openSection: null,
        // 設定されている降下条件で降下対象となる選択肢数（算出自体はサーバーサイド）
        // nullはエラーとみなします
        cutCandidatesCount: 0,
        isCalculatingCutCandidatesCount: false,
      },
      // 顧客接点追加パラメーター設定ダイアログ上で任意に変更できる項目のスナップショット
      // ダイアログで「反映する」まで一時的な変更置き場
      reportEditParametersSnapshot: {
        leaf: {
          columns: [],
        },
        adoptOrder: undefined,
        orderAdjustment: {
          optionsInSelection: {
            selected: false,
            value: 0,
          },
          unnecessarySelection: {
            selected: false,
            value: 0,
          },
          priority: undefined,
          cutWhenApplicable: true,
        },
        facingMin: 0,
        facingMax: 0,
        restockCycleDays: 0,
        stockCoefficientAll: 0,
        stockCoefficient1st: 0,
        stockCoefficient2nd: 0,
        cutCount: 0,
        maxPatternCount: 0,
        patternLabel: undefined,
        cutLabel: undefined,
        itemDistributionMode: 'count',
        itemDistributionCount: 0,
        itemDistributionCountMin: 1,
        itemDistributionCountMax: 1,
        recommendsToDistributeItemCount: undefined,
        spaceDistributionMode: 'count',
        spaceDistributionCount: 0,
        spaceDistributionCountMin: 1,
        spaceDistributionCountMax: 1,
      },
      // パラメーター設定ダイアログで変更採用順に影響を与えるパラメーター変更Subject
      orderAdjustmentParamChangeSubject: new Subject(),
      /**
       * 分析結果
       */
      resultTable: {
        item: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'row_num',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            store_detail: (rowData, cell) => {
              cell.classList.add('customer-collection-cell')
              cell.addEventListener('click', () => {
                this.showStoreDetail(rowData.item_code)
              })
            },
            leaf_detail: (rowData, cell) => {
              cell.classList.add('customer-collection-cell')
              cell.addEventListener('click', () => {
                this.showLeafDetail(rowData.item_code)
              })
            },
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')

              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.item.columns) {
                  throw new Error('Column not found')
                }

                // hit the column
                const col = this.resultTable.item.columns.find(
                  c => c.colName === colName,
                )

                const id = e.target.getAttribute('data-customer-collection')
                let text = ''

                // 基本の名称
                if (colName.startsWith('item_')) {
                  text += rowData.item_name || 'マーケット計'
                } else if (colName.startsWith('seg_f_')) {
                  text += rowData.seg_f_name || 'マーケット計'
                } else if (colName.startsWith('seg_n_')) {
                  text += rowData.seg_n_name || 'マーケット計'
                }

                // ＋付加情報
                if (
                  colName.startsWith('item_r') ||
                  colName.startsWith('item_t') ||
                  colName.startsWith('seg_f_r_') ||
                  colName.startsWith('seg_f_t_') ||
                  colName.startsWith('seg_n_r_') ||
                  colName.startsWith('seg_n_t_')
                ) {
                  text += ` - ${col.headerText}`
                }

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (colName.startsWith('segment')) {
                  return
                }
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
            manual_cut: (rowData, cell) => {
              // クエリパラメータでの送信データ圧縮のために関連順を使う
              const value = rowData.row_num

              if (!value) {
                return
              }

              cell.title = 'クリックで採用・不採用を手動で切替'

              cell.classList.add('manual-cut-toggle')

              if (this.manualCutCandidateAndIds.includes(value)) {
                cell.classList.add('manual-cut-toggle--visible')
              }

              if (this.manualCut.ids.includes(value)) {
                const isCut = rowData.order_adjusted === 0
                cell.classList.add(
                  isCut ? 'manual-cut-toggle--cut' : 'manual-cut-toggle--alive',
                )
              }

              cell.addEventListener('click', () => {
                if (this.manualCut.candidates.includes(value)) {
                  // remove
                  this.manualCut.candidates = this.manualCut.candidates.filter(
                    c => c !== value,
                  )
                  cell.classList.toggle('manual-cut-toggle--visible')
                } else {
                  // add
                  if (this.manualCut.candidates.length >= this.manualCut.max) {
                    this.$dialog.open(
                      DialogWarning,
                      `手動採用／不採用に指定できる顧客接点数の上限に達しました（最大${
                        this.manualCut.max
                      }）`,
                    )
                  } else {
                    this.manualCut.candidates = [
                      ...this.manualCut.candidates,
                      value,
                    ]
                    cell.classList.toggle('manual-cut-toggle--visible')
                  }
                }
              })
            },
            storeCountLineBreak: (cell, headerText) => {
              // e.g. headerText = 店舗数（123店舗中）
              const m = /^(店舗数)（(\d+)店舗中）$/.exec(headerText)
              if (!m) {
                return
              }

              const count = m[2]
              // HTML文字列を流し込まず、DOMを組み立てて安全に描画する
              cell.textContent = ''
              cell.append(document.createTextNode('店舗数'))
              cell.append(document.createElement('br'))
              cell.append(document.createTextNode('（'))
              const span = document.createElement('span')
              span.style.fontWeight = 'bold'
              span.textContent = count
              cell.append(span)
              cell.append(document.createTextNode('店舗中）'))
            },
            linkifySearch: searchCellCustomFunction,
          },
        },
        segmentF: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'row_num',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.segmentF.columns) {
                  throw new Error('Column not found')
                }

                // hit the column
                const col = this.resultTable.segmentF.columns.find(
                  c => c.colName === colName,
                )

                const id = e.target.getAttribute('data-customer-collection')
                let text = ''

                // セグメントの名称
                text += rowData.seg_f_name || 'マーケット計'

                // ＋年代などの付加情報
                if (colName.startsWith('customer_count_ratio_')) {
                  text += ` - ${col.headerText}`
                } else if (
                  colName === 't_customer_count' ||
                  colName === 'r_customer_count'
                ) {
                  text += ` - ${col.headerText}`
                }

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
          },
        },
        segmentN: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'row_num',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            // TODO WET
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.segmentN.columns) {
                  throw new Error('Column not found')
                }
                // hit the column
                const col = this.resultTable.segmentN.columns.find(
                  c => c.colName === colName,
                )

                const id = e.target.getAttribute('data-customer-collection')
                let text = ''

                // セグメントの名称
                text += rowData.seg_f_name || 'マーケット計'

                // ＋年代などの付加情報
                if (colName.startsWith('customer_count_ratio_')) {
                  text += ` - ${col.headerText}`
                } else if (
                  colName === 't_customer_count' ||
                  colName === 'r_customer_count'
                ) {
                  text += ` - ${col.headerText}`
                }

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
          },
        },
        leafDetail: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'store_code',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            // TODO WET
            linkify: (rowData, cell, value, colName) => {
              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.leafDetail.columns) {
                  throw new Error('Column not found')
                }

                const id = e.target.getAttribute('data-customer-collection')
                let text = ''

                text += `単品 - ${rowData.ymd} | ${rowData.store_name} | ${
                  rowData.item_name
                }`

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
            linkifySearch: searchCellCustomFunction,
          },
        },
        storeDetail: {
          columns: undefined,
          groupHeaders: undefined,
          sortColumnName: 'store_code',
          sortOrder: 'asc',
          url: undefined,
          width: 0,
          height: 0,
          customFormatter: {
            // TODO WET
            linkify: (rowData, cell, value, colName) => {
              if (!value) {
                return
              }

              cell.classList.add('customer-collection-cell')
              cell.setAttribute(
                'data-customer-collection',
                rowData.customer_filter[colName],
              )

              const toggle = e => {
                if (!this.resultTable.leafDetail.columns) {
                  throw new Error('Column not found')
                }

                const id = e.target.getAttribute('data-customer-collection')
                let text = ''

                text += `店舗 - ${rowData.parent_name} | ${rowData.store_name}`

                const customer = { id, text }

                this.$emit('toggle-customer-collection', customer)
              }

              cell.addEventListener('mousedown', e => {
                hold = true
                document.body.classList.add('no-select')
                toggle(e)
              })
              cell.addEventListener('mouseup', () => {
                hold = false
                document.body.classList.remove('no-select')
              })

              cell.addEventListener('mouseenter', e => {
                if (!hold) {
                  return
                }
                toggle(e)
              })
            },
            linkifySearch: searchCellCustomFunction,
          },
        },
        additionalExplanationHeightPx: 60,
      },
      // リーフ詳細で表示しているコード
      focusingItemCode: {
        leafDetail: undefined,
        storeDetail: undefined,
      },
      files: {
        dendrogram: {
          path: undefined,
          noImageReason: undefined,
        },
        distMatrix: undefined,
        distMatrixSjis: undefined,
      },
      /**
       * 不採用などの選択中ダイアログ
       */
      editReport: false,
      /**
       * デンドログラム画像なし理由
       */
      noImageReason: undefined,
      /**
       * 採用順赤フォントボーダーID数構成比
       */
      customerCountRatioBorder: 1,
      /**
       * 階層ファイルアップロード中
       */
      uploadingItemFile: false,
      /**
       * この画面が持つ分析条件を、クエリのペイロードに変換する
       */
      mapQueryFilterForApi: async queryFilter => {
        let itemPayload = {}
        let itemCategoryPayload = {}

        if (queryFilter.leaf.type !== 'itemCategory') {
          itemPayload = item.mapToApiPayload(queryFilter.marketItems.item)
        } else {
          itemCategoryPayload = category.mapToApiPayload(
            queryFilter.marketItems.category,
          )
        }

        const leaf = {
          type: queryFilter.leaf.type,
          minCustomerCount: queryFilter.leaf.minCustomerCount,
          columns: queryFilter.leaf.columns,
        }

        const option = {
          adoptOrder: queryFilter.option.adoptOrder,
          orderAdjustment: queryFilter.option.orderAdjustment,
          r: queryFilter.option.r,
          priceLine: queryFilter.option.priceLine,
          minuteStep: queryFilter.option.minuteStep,
          usePotentiallyDangerousShinKappaDistCalc:
            queryFilter.option.usePotentiallyDangerousShinKappaDistCalc,
          shinKappaCustomerSamplingMax: queryFilter.option
            .usePotentiallyDangerousShinKappaDistCalc
            ? queryFilter.option.shinKappaCustomerSamplingMax
            : 0,
        }

        return {
          leaf,
          item: itemPayload,
          category: itemCategoryPayload,
          term: term.mapToApiPayload(queryFilter.term),
          store: store.mapToApiPayload(queryFilter.store),
          option,
        }
      },
      /**
       * 渡された分析条件をこの画面の分析条件に反映する
       */
      applyQueryFilter: queryFilter => {
        term.applyPayload(this.queryFilter.term, queryFilter.term)
        store.applyPayload(this.queryFilter.store, queryFilter.store)

        const itemPromise = item.applyPayload(
          this.queryFilter.marketItems.item,
          queryFilter.marketItems.item,
        )
        category.applyPayload(
          this.queryFilter.marketItems.category,
          queryFilter.marketItems.category,
        )

        this.queryFilter.leaf.type = queryFilter.leaf.type
        this.queryFilter.leaf.minCustomerCount =
          queryFilter.leaf.minCustomerCount
        this.queryFilter.leaf.columns.day = queryFilter.leaf.columns.day
        this.queryFilter.leaf.columns.item = queryFilter.leaf.columns.item
        this.queryFilter.leaf.columns.itemCategory =
          queryFilter.leaf.columns.itemCategory
        this.queryFilter.leaf.columns.store = queryFilter.leaf.columns.store
        this.queryFilter.leaf.columns.ymd = queryFilter.leaf.columns.ymd
        this.queryFilter.leaf.columns.priceLine =
          queryFilter.leaf.columns.priceLine

        this.queryFilter.option.adoptOrder = queryFilter.option.adoptOrder
        this.queryFilter.option.orderAdjustment.optionsInSelection.selected =
          queryFilter.option.orderAdjustment.optionsInSelection.selected
        this.queryFilter.option.orderAdjustment.optionsInSelection.value =
          queryFilter.option.orderAdjustment.optionsInSelection.value
        this.queryFilter.option.orderAdjustment.unnecessarySelection.selected =
          queryFilter.option.orderAdjustment.unnecessarySelection.selected
        this.queryFilter.option.orderAdjustment.unnecessarySelection.value =
          queryFilter.option.orderAdjustment.unnecessarySelection.value
        this.queryFilter.option.r = queryFilter.option.r
        this.queryFilter.option.priceLine = queryFilter.option.priceLine
        this.queryFilter.option.minuteStep = queryFilter.option.minuteStep || 10
        this.queryFilter.option.stockCoefficientAll =
          queryFilter.option.stockCoefficientAll !== undefined
            ? queryFilter.option.stockCoefficientAll
            : this.queryFilter.option.stockCoefficientAll
        this.queryFilter.option.stockCoefficient1st =
          queryFilter.option.stockCoefficient1st !== undefined
            ? queryFilter.option.stockCoefficient1st
            : this.queryFilter.option.stockCoefficient1st
        this.queryFilter.option.stockCoefficient2nd =
          queryFilter.option.stockCoefficient2nd !== undefined
            ? queryFilter.option.stockCoefficient2nd
            : this.queryFilter.option.stockCoefficient2nd

        return [itemPromise]
      },
      /**
       * 顧客コレクション
       */
      customerCollection: [],
      /**
       * Excel出力のパラメータ生成
       */
      excelPropertiesHandler() {
        // 応急処置（顧客接点のパラメータは多いのでcomposeItemDataUrlと一部共通にしたほうがいいかも）
        const leafParams = {}
        const params = {
          append(key, value) {
            leafParams[key] = value
          },
        }

        // 採用順算出ベース
        params.append('adoptOrder', this.queryFilter.option.adoptOrder)

        // 採用順降下条件
        params.append(
          'orderAdjustment1',
          this.queryFilter.option.orderAdjustment.optionsInSelection.selected
            ? this.queryFilter.option.orderAdjustment.optionsInSelection.value
            : 0,
        )
        params.append(
          'orderAdjustment2',
          this.queryFilter.option.orderAdjustment.unnecessarySelection.selected
            ? this.queryFilter.option.orderAdjustment.unnecessarySelection
                .value / 100
            : 0,
        )
        params.append(
          'orderAdjustmentPriority',
          this.queryFilter.option.orderAdjustment.priority ===
            'optionsInSelection'
            ? 1
            : 2,
        )
        params.append(
          'cutWhenApplicable',
          this.queryFilter.option.orderAdjustment.cutWhenApplicable ? 1 : 0,
        )

        // 不採用
        params.append('cutCount', this.reportEditParameters.cutCount)

        // 棚割パターン割付
        params.append(
          'maxPatternCount',
          this.reportEditParameters.maxPatternCount,
        )
        params.append('patternLabel', this.reportEditParameters.patternLabel)
        params.append('cutLabel', this.reportEditParameters.cutLabel)
        params.append('facingMin', this.queryFilter.option.facingMin)
        params.append('facingMax', this.queryFilter.option.facingMax)
        params.append(
          'restockCycleDays',
          this.queryFilter.option.restockCycleDays,
        )

        // 在庫係数
        params.append(
          'stockCoefficientAll',
          this.queryFilter.option.stockCoefficientAll,
        )
        params.append(
          'stockCoefficient1st',
          this.queryFilter.option.stockCoefficient1st,
        )
        params.append(
          'stockCoefficient2nd',
          this.queryFilter.option.stockCoefficient2nd,
        )

        // 販促単品分配
        params.append(
          'itemDistributionCount',
          this.reportEditParameters.itemDistributionMode === 'count'
            ? this.reportEditParameters.itemDistributionCount
            : 0,
        )
        params.append(
          'itemDistributionCountMin',
          this.reportEditParameters.itemDistributionMode === 'range'
            ? this.reportEditParameters.itemDistributionCountMin
            : 0,
        )
        params.append(
          'itemDistributionCountMax',
          this.reportEditParameters.itemDistributionMode === 'range'
            ? this.reportEditParameters.itemDistributionCountMax
            : 0,
        )
        if (
          this.reportEditParameters.recommendsToDistributeItemCount !== 'all'
        ) {
          params.append(
            'recommendsToDistributeItemCount',
            this.reportEditParameters.recommendsToDistributeItemCount,
          )
        }

        // 理論スペース分配
        params.append(
          'spaceDistributionCount',
          this.reportEditParameters.spaceDistributionMode === 'count'
            ? this.reportEditParameters.spaceDistributionCount
            : 0,
        )
        params.append(
          'spaceDistributionCountMin',
          this.reportEditParameters.spaceDistributionMode === 'range'
            ? this.reportEditParameters.spaceDistributionCountMin
            : 0,
        )
        params.append(
          'spaceDistributionCountMax',
          this.reportEditParameters.spaceDistributionMode === 'range'
            ? this.reportEditParameters.spaceDistributionCountMax
            : 0,
        )

        // 手動不採用
        if (this.manualCut.ids.length > 0) {
          params.append('manualCutToggle', this.manualCut.ids.join(','))
        }

        // ================================================
        // 単品/店舗詳細
        // ================================================
        if (
          this.activeResultTab === 'leaf_detail' ||
          this.activeResultTab === 'store_detail'
        ) {
          const parentCode =
            this.activeResultTab === 'leaf_detail'
              ? this.focusingItemCode.leafDetail
              : this.focusingItemCode.storeDetail

          if (parentCode === undefined) {
            this.$dialog.open(
              DialogWarning,
              '単品/店舗詳細をCSV出力するには、まず出力したい顧客接点を選択してください。',
            )
            return false
          }

          if (parentCode) {
            params.append('parentCode', parentCode)
          }

          const sort =
            this.activeResultTab === 'leaf_detail'
              ? this.$refs.leafDetailTable.getCurrentSort()
              : this.$refs.storeDetailTable.getCurrentSort()

          params.append('outputDetailTable', this.activeResultTab)
          params.append('sortColumnName', sort.name)
          params.append('sortOrder', sort.order)

          return leafParams
        }

        // ================================================
        // 顧客接点〜選択範囲
        // ================================================

        // 現在の表示列
        // URLSearchParamsは配列に対応していません（というかそもそもSearchParamで
        // 配列を送る表記の仕方の規定はない）。とりあえずカンマ連結文字列でお茶を濁します。
        const visibleItemColumns = this.resultTable.item.columns
          .filter(c => !c.hidden)
          .map(c => c.colName)
          .join(',')
        const visibleSegFColumns = this.resultTable.segmentF.columns
          .filter(c => !c.hidden)
          .map(c => c.colName)
          .join(',')
        const visibleSegNColumns = this.resultTable.segmentN.columns
          .filter(c => !c.hidden)
          .map(c => c.colName)
          .join(',')

        // 表示列
        params.append('visibleItemColumns', visibleItemColumns)
        params.append('visibleSegFColumns', visibleSegFColumns)
        params.append('visibleSegNColumns', visibleSegNColumns)

        // 現在のグリッドソート情報
        const itemSort = this.$refs.itemTable.getCurrentSort()
        const segFSort = this.$refs.segmentFTable.getCurrentSort()
        const segNSort = this.$refs.segmentNTable.getCurrentSort()

        return {
          ...leafParams,
          itemSortColumnName: itemSort.name,
          itemSortOrder: itemSort.order,
          segFSortColumnName: segFSort.name,
          segFSortOrder: segFSort.order,
          segNSortColumnName: segNSort.name,
          segNSortOrder: segNSort.order,
        }
      },
      isDetail: false,
      // 手動採用／不採用
      manualCut: {
        candidates: [],
        ids: [],
        max: MAX_MANUAL_CUT_TOGGLE_COUNT,
      },
      experimentalAi: {
        enabled: process.env.VUE_APP_SHIN_TAPIR_AI_AGENT_VISIBLE === '1',
        leafOfThisQuery: undefined, // 表示している分析で選択されたリーフ
        maxLeafCount: 500,
        leafCount: 0,
        parameterSnapshot: {},
        isInInterval: false,
        intervalSeconds: 5,
        showClipboardCopiedMessage: false,
        // ニーズ要約
        segmentDescription: {
          isDialogOpen: false,
          leafAllowed: ['item', 'store', 'ymd'],
          isAiGenerating: false,
          hasGenerated: false, // 生成済みか？
          isVisibleInResult: false, // 分析結果に表示するか？
        },
        // 新商品の提案
        newItemSuggestion: {
          isDialogOpen: false,
          leafAllowed: ['item'],
          isAiGenerating: false,
          suggestions: [],
        },
        // 新商品の陳列位置の推論
        newItemPositionSuggestion: {
          isDialogOpen: false,
          leafAllowed: ['item'],
          isAiGenerating: false,
          newItemData: '', // ユーザー入力
          suggestions: [],
        },
        // カット候補商品のレコメンド
        cutCandidateRecommendation: {
          isDialogOpen: false,
          leafAllowed: ['item'],
          isAiGenerating: false,
          recommendations: [],
          excludedItems: [], // 不採用チェックを入れた rowNum（関連順）の配列
        },
        recommendNonSalesStores: {
          isDialogOpen: false,
          leafAllowed: ['item'],
          isAiGenerating: false,
          includeThirdRecommend: false,
          downloadUrls: [],
        },
        planogramSoftwareColoringFile: {
          isDialogOpen: false,
          leafAllowed: ['item'],
          isAiGenerating: false,
        },
        couponTargetCustomerFile: {
          isDialogOpen: false,
          leafAllowed: ['item'],
          isAiGenerating: false,
          hasGenerated: false, // 生成済みか？
          itemCodesInput: '', // ユーザー入力商品コード
          existingItemCodes: [
            // e.g.
            // { itemCode: '0000000001', itemName: 'サンプル商品1', exists: true },
            // { itemCode: '0000000002', itemName: null, exists: false },
          ],
          customerCountSegF: 0,
          customerCountSegN: 0,
          customerCountLeaf: 0,
          showNotExistingItemCodes: false,
        },
      },
    }
  },
  computed: {
    itemCompany: {
      get() {
        return this.queryFilter.leaf.type !== 'itemCategory'
          ? this.queryFilter.marketItems.item.company
          : this.queryFilter.marketItems.category.company
      },
      set(v) {
        this.queryFilter.marketItems.item.company = v
        this.queryFilter.marketItems.category.company = v
      },
    },
    cutRatio() {
      if (this.leafTotalCount === 0) {
        return 0
      }

      return Math.round(
        (this.reportEditParametersSnapshot.cutCount / this.leafTotalCount) *
          100,
      )
    },
    candidatesCutRatio() {
      if (this.leafTotalCount === 0) {
        return 0
      }

      return Math.round(
        (this.reportEditParameters.cutCandidatesCount / this.leafTotalCount) *
          100,
      )
    },
    // 採用順降下に関わるパラメータ（抜粋）
    // 不採用数試算トリガー目的で監視しています
    orderAdjustmentRelatedParameters() {
      return {
        adoptOrder: this.reportEditParametersSnapshot.adoptOrder,
        orderAdjustment: {
          optionsInSelection: {
            selected: this.reportEditParametersSnapshot.orderAdjustment
              .optionsInSelection.selected,
            value: this.reportEditParametersSnapshot.orderAdjustment
              .optionsInSelection.value,
          },
          unnecessarySelection: {
            selected: this.reportEditParametersSnapshot.orderAdjustment
              .unnecessarySelection.selected,
            value: this.reportEditParametersSnapshot.orderAdjustment
              .unnecessarySelection.value,
          },
          priority: this.reportEditParametersSnapshot.orderAdjustment.priority,
        },
      }
    },
    _additionalColumns() {
      const leafType = this.queryFilter.leaf.type

      return this.columns.map(c => ({
        id: c.id,
        label: c.label,
        hidden: ADDITIONAL_COLUMNS_PRESETS[leafType].hidden.includes(c.id),
        recommended: ADDITIONAL_COLUMNS_PRESETS[leafType].selected.includes(
          c.id,
        ),
      }))
    },
    reportEditDiologOpenState() {
      const openSection = this.reportEditParameters.openSection

      const sections = [
        'additionalColumns',
        'adoptOrder',
        'orderAdjustment',
        'cut',
        'pattern',
        'itemDistribution',
        'spaceDistribution',
      ]

      return Object.fromEntries(
        sections.map(s => [s, !openSection || openSection === s]),
      )
    },
    existLeafDetailUrl() {
      return Boolean(this.resultTable.leafDetail.url)
    },
    existStoreDetailUrl() {
      return Boolean(this.resultTable.storeDetail.url)
    },
    isUserSelectingManualCut() {
      if (this.manualCut.candidates.length !== this.manualCut.ids.length) {
        return true
      }

      const candidates = JSON.stringify([...this.manualCut.candidates].sort())
      const ids = JSON.stringify([...this.manualCut.ids].sort())

      return candidates !== ids
    },
    manualCutCandidateAndIds() {
      return Array.from(
        new Set([...this.manualCut.candidates, ...this.manualCut.ids]),
      )
    },
    experimentalAiMenuLeafType() {
      return this.experimentalAi.leafOfThisQuery || this.queryFilter.leaf.type
    },
    existingItemCodesText() {
      if (
        this.experimentalAi.couponTargetCustomerFile.existingItemCodes
          .length === 0
      ) {
        return ''
      }

      return this.experimentalAi.couponTargetCustomerFile.existingItemCodes
        .filter(e =>
          this.experimentalAi.couponTargetCustomerFile.showNotExistingItemCodes
            ? true
            : e.exists,
        )
        .map(
          e =>
            `${e.itemCode}\t${
              e.exists ? e.itemName : '（分析結果には含まれていません）'
            }`,
        )
        .join('\n')
    },
  },
  // マーケット構成単品／分類のあれこれのせいで色々無理なことをしている...
  watch: {
    'queryFilter.leaf.type'(newValue) {
      // 分析条件サマリに今リーフが分類なのか分類以外なのかを伝えたい
      this.queryFilter.marketItems.isLeafCategory = newValue === 'itemCategory'
    },
    // 分析条件のエラーAggregration
    'queryFilter.marketItems.item.errors'(newValue) {
      if (this.queryFilter.leaf.type === 'itemCategory') {
        // 顧客接点の選択が分類なので、単品選択のエラーは無視して良い
        this.queryFilter.marketItems.errors = []
      } else {
        this.queryFilter.marketItems.errors = newValue
      }
    },
    // 分析条件のエラーAggregration
    'queryFilter.marketItems.category.errors'(newValue) {
      if (this.queryFilter.leaf.type === 'itemCategory') {
        this.queryFilter.marketItems.errors = newValue
      } else {
        // 顧客接点の選択が分類以外なので、分類選択のエラーは無視して良い
        this.queryFilter.marketItems.errors = []
      }
    },
    orderAdjustmentRelatedParameters(newValue) {
      if (this.leafTotalCount === 0) {
        // 分析中にリロードなどを行い分析中に画面表示を行った場合、分析条件の復元
        // などをトリガーにこのウォッチャーが動くことがあります。
        // 分析が完了していない状態で降下対象件数を取得することはできないのでスキップします。
        this.reportEditParameters.isCalculatingCutCandidatesCount = false
        return
      }

      this.orderAdjustmentParamChangeSubject.next(JSON.stringify(newValue))
    },
    'experimentalAi.segmentDescription.isVisibleInResult'() {
      this.reloadGrids()
    },
  },
  methods: {
    isExperimentalAiMenuItemDisabled(featureKey) {
      return !this.experimentalAi[featureKey].leafAllowed.includes(
        this.experimentalAiMenuLeafType,
      )
    },
    experimentalAiMenuItemTooltip(featureKey) {
      if (!this.isExperimentalAiMenuItemDisabled(featureKey)) {
        return ''
      }

      const availableLeafLabels = this.experimentalAi[featureKey].leafAllowed
        .map(leafType => this.leafTypeLabels[leafType])
        .join('、')

      return `利用可能な顧客接点: ${availableLeafLabels}`
    },
    openExperimentalAiDialog(featureKey) {
      if (this.isExperimentalAiMenuItemDisabled(featureKey)) {
        return
      }

      this.experimentalAi[featureKey].isDialogOpen = !this.experimentalAi[
        featureKey
      ].isDialogOpen
    },
    isTheLeafSelectable(leafType) {
      if (leafType === LEAF_TYPES.time) {
        if (!this.$store.state.site.hasPosTime) {
          return { selectable: false, reason: '時間帯データ連携なし' }
        }
      }
      return { selectable: true }
    },
    resetColumnSelection(isSnapshot = false) {
      if (isSnapshot) {
        this.reportEditParametersSnapshot.leaf.columns = getPresetSelection()[
          this.queryFilter.leaf.type
        ]
        return
      }

      this.queryFilter.leaf.columns = getPresetSelection()
    },
    onQueryCompleted({ queryInfo }) {
      if (!queryInfo.data) {
        return { stop: false }
      }

      const data = JSON.parse(queryInfo.data)

      if (data.message) {
        this.$dialog.open(DialogWarning, data.message)
        return { stop: true }
      }

      return { stop: false }
    },
    async loadData(queryInfo) {
      const queryFilter = this.queryFilter
      const data = JSON.parse(queryInfo.data)

      if (this.experimentalAi.enabled) {
        // 結果画面リロード対策で、結果ロード時にはAI説明が生成済みか問い合わせる
        const generated = await repository.giggle
          .get(
            `/api/shin-tapir/${
              queryInfo.id
            }/fetch/experimental/ai_description/generated`,
          )
          .then(r => r.data)

        this.experimentalAi.segmentDescription.hasGenerated = generated
        if (!generated) {
          // 一つ前の分析結果閲覧時に生成＆有効にされている可能性があります。
          // 現状生成されていない場合は強制的に非表示にします。
          this.experimentalAi.segmentDescription.isVisibleInResult = false
        }

        // リーフによる機能制限があるのでキャッシュしておく
        this.experimentalAi.leafOfThisQuery = queryFilter.leaf.type
        this.experimentalAi.leafCount = data.numRows.leaf - 1 // 1行は合計行
      }

      this.leafTotalCount = data.numRows.leaf - 1 // 1行は合計行

      this.files.dendrogram.path = data.files.dendrogram.path
      this.files.dendrogram.noImageReason =
        data.files.dendrogram.no_image_reason
      this.files.distMatrix = data.files.dist_matrix
      this.files.distMatrixSjis = data.files.dist_matrix_sjis

      const company = queryFilter.marketItems.item.company

      // APIからColModelを取得
      const colModels = await Promise.all([
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              `item?company=${company}&adoptOrder=${
                queryFilter.option.adoptOrder
              }`,
            ),
          )
          .then(r => r.data),
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              `segment?company=${company}`,
            ),
          )
          .then(r => r.data),
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              `leafDetail?company=${company}`,
            ),
          )
          .then(r => r.data),
        repository.giggle
          .get(
            this.$longQuery.getColModelFetchUrl(
              this.resourceName,
              queryInfo.id,
              `storeDetail?company=${company}`,
            ),
          )
          .then(r => r.data),
      ])

      // 全列共通フォーマッター追加（アタッチするのはJavaScript関数でありサーバーサイドからは連携されないので）
      for (const models of colModels) {
        for (const m of models.colModel) {
          m.customFormatter = attributes
        }
      }

      const itemCol = colModels[0]
      const summaryCol = colModels[1]
      const leafDetailCol = colModels[2]
      const storeDetailCol = colModels[3]

      setVisibleColumns(
        'leaf',
        itemCol.colModel,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )
      setVisibleColumns(
        'segN', // この時点ではsegFとsegNはseg_n_nameの有無しか違いがない
        summaryCol.colModel,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )

      this.resultTable.item.groupHeaders = itemCol.groupHeader
      this.resultTable.item.columns = itemCol.colModel.map(c => {
        if (c.colName === 'store_count') {
          return {
            ...c,
            headerCell: 'storeCountLineBreak',
          }
        }
        return c
      })

      this.resultTable.segmentF.groupHeaders = summaryCol.groupHeader
      this.resultTable.segmentF.columns = summaryCol.colModel
      this.resultTable.segmentF.columns = summaryCol.colModel.map(c => {
        const copy = { ...c }
        if (c.colName === 'seg_n_name') {
          copy.hidden = true
        }
        return copy
      })

      this.resultTable.segmentN.groupHeaders = summaryCol.groupHeader
      this.resultTable.segmentN.columns = summaryCol.colModel

      this.resultTable.leafDetail.columns = leafDetailCol.colModel
      this.resultTable.storeDetail.columns = storeDetailCol.colModel

      this.manualCut.ids = []
      this.manualCut.candidates = []

      // 分析完了時には必ず一回採用順降下件数のセットを行います
      // （Subject任せだと値が変わらない限り再取得されないので）
      this.reportEditParameters.cutCandidatesCount = await this.getOrderAdjustedCount(
        {
          adoptOrder: this.queryFilter.option.adoptOrder,
          orderAdjustment: {
            optionsInSelection: {
              selected: this.queryFilter.option.orderAdjustment
                .optionsInSelection.selected,
              value: this.queryFilter.option.orderAdjustment.optionsInSelection
                .value,
            },
            unnecessarySelection: {
              selected: this.queryFilter.option.orderAdjustment
                .unnecessarySelection.selected,
              value: this.queryFilter.option.orderAdjustment
                .unnecessarySelection.value,
            },
            priority: this.queryFilter.option.orderAdjustment.priority,
          },
        },
      )

      // 自動実行ONで分析した場合、算出したカット候補数を強制的にカットカウントにします
      // これは分析実行時にだけ行い、以降はダイアログから任意の値に変更します
      if (this.queryFilter.option.orderAdjustment.cutWhenApplicable) {
        this.reportEditParameters.cutCount = this.reportEditParameters.cutCandidatesCount
      }

      // 結果表示テーブルのURL設定
      const itemUrl = await this.composeItemDataUrl()
      const segFUrl = await this.composeSegmentDataUrl('f')
      const segNUrl = await this.composeSegmentDataUrl('n')

      this.resultTable.item.url = itemUrl
      this.resultTable.segmentF.url = segFUrl
      this.resultTable.segmentN.url = segNUrl
      // 分析した際には、単品詳細、店舗詳細の中身をクリアする
      this.resultTable.leafDetail.url = undefined
      this.focusingItemCode.leafDetail = undefined
      this.resultTable.storeDetail.url = undefined
      this.focusingItemCode.storeDetail = undefined

      this.activeResultTab = 'leaf'
    },
    // リーフテーブルのヘッダクリックにより動的パラメーター変更のための
    // ダイアログを開くことができるようヘッダセルをいじります。
    setHeaderLinks({ headerTable }) {
      // 顧客接点追加パラメーター設定を開くリンクを付与するヘッダー
      // キー：ヘッダのテキスト、値：開くダイアログのセクションID
      const headerTextValueMap = {
        算出ベース: 'adoptOrder',
        '採用／不採用': 'orderAdjustment',
        棚割パターン割付: 'pattern',
        '棚割理論値（サイズ・積上考慮なし）': 'pattern',
        '1店舗x日換算': 'pattern',
        販促単品分配: 'itemDistribution',
        理論スペース分配: 'spaceDistribution',
      }
      const targetGroupHeaderTexts = Object.keys(headerTextValueMap)
      const setParameterSettingsLink = (th, text) => {
        let modifiedHeaderText = undefined
        switch (text) {
          case '算出ベース':
            // 算出ベースのヘッダテキストには現在選択している算出ベースを追加表示します
            modifiedHeaderText = `${text}=${
              ADOPT_ORDER_LABELS[this.queryFilter.option.adoptOrder]
            }`
            break
          case '1店舗x日換算':
            // 棚割理論値のヘッダテキストには現在選択している補充サイクルを追加表示します
            modifiedHeaderText = `1店舗${
              this.queryFilter.option.restockCycleDays
            }日換算`
            break
          default:
            modifiedHeaderText = text
        }

        // 顧客接点追加パラメーター設定を開くリンク
        const link = document.createElement('span') // リンク（っぽい）テキストに差し替える

        // link-cellは分析の有効/無効に引きずられてデザインが変わってしまうので、
        // 安直ですが色だけとりあえず戻します。
        link.style.color = 'var(--color-primary)'

        link.textContent = modifiedHeaderText
        link.addEventListener('click', () => {
          this.openReportEditDialog(headerTextValueMap[text])
        })
        th.textContent = ''

        th.appendChild(link)

        th.classList.add('link-cell')
      }

      // マニュアルリンクを追加するヘッダー
      const headersToAddManualLinkMap = {
        客数: '表示項目一覧',
      }
      const headersToAddManualLink = Object.keys(headersToAddManualLinkMap)
      const setManualLink = (th, text) => {
        const link = document.createElement('a')

        link.href = `${process.env.VUE_APP_HELP_SITE_URL_BASE}${
          this.resourceName
        }.html#${headersToAddManualLinkMap[text]}`
        link.target = '_blank'

        link.textContent = '（？）'

        th.appendChild(link)
      }

      for (const th of headerTable.getElementsByTagName('th')) {
        let textFound = targetGroupHeaderTexts.find(t => th.textContent === t)
        if (textFound) {
          setParameterSettingsLink(th, textFound)
        }

        textFound = headersToAddManualLink.find(t => th.textContent === t)
        if (textFound) {
          setManualLink(th, textFound)
        }
      }
    },
    // 顧客接点追加パラメーター設定ダイアログを開きます
    // sectionはダイアログ表示時にフォーカスするセクションIDです。
    // フォーカスしない場合は ''
    openReportEditDialog(section) {
      this.reportEditParametersSnapshot = {
        leaf: {
          columns: this.queryFilter.leaf.columns[
            this.queryFilter.leaf.type
          ].slice(),
        },
        adoptOrder: this.queryFilter.option.adoptOrder,
        orderAdjustment: {
          optionsInSelection: {
            selected: this.queryFilter.option.orderAdjustment.optionsInSelection
              .selected,
            value: this.queryFilter.option.orderAdjustment.optionsInSelection
              .value,
          },
          unnecessarySelection: {
            selected: this.queryFilter.option.orderAdjustment
              .unnecessarySelection.selected,
            value: this.queryFilter.option.orderAdjustment.unnecessarySelection
              .value,
          },
          priority: this.queryFilter.option.orderAdjustment.priority,
        },
        cutCount: this.reportEditParameters.cutCount,
        maxPatternCount: this.reportEditParameters.maxPatternCount,
        patternLabel: this.reportEditParameters.patternLabel,
        cutLabel: this.reportEditParameters.cutLabel,
        facingMin: this.queryFilter.option.facingMin,
        facingMax: this.queryFilter.option.facingMax,
        restockCycleDays: this.queryFilter.option.restockCycleDays,
        stockCoefficientAll: this.queryFilter.option.stockCoefficientAll,
        stockCoefficient1st: this.queryFilter.option.stockCoefficient1st,
        stockCoefficient2nd: this.queryFilter.option.stockCoefficient2nd,
        itemDistributionMode: this.reportEditParameters.itemDistributionMode,
        itemDistributionCount: this.reportEditParameters.itemDistributionCount,
        itemDistributionCountMin: this.reportEditParameters
          .itemDistributionCountMin,
        itemDistributionCountMax: this.reportEditParameters
          .itemDistributionCountMax,
        recommendsToDistributeItemCount: this.reportEditParameters
          .recommendsToDistributeItemCount,
        spaceDistributionMode: this.reportEditParameters.spaceDistributionMode,
        spaceDistributionCount: this.reportEditParameters
          .spaceDistributionCount,
        spaceDistributionCountMin: this.reportEditParameters
          .spaceDistributionCountMin,
        spaceDistributionCountMax: this.reportEditParameters
          .spaceDistributionCountMax,
      }

      this.reportEditParameters.openSection = section
      this.editReport = true
    },
    async applyReportEditDialogSnapshot() {
      const normalizeDistributionRange = (mode, min, max) => {
        if (mode !== 'range') {
          return {
            min: Math.min(min, max),
            max: Math.max(min, max),
          }
        }

        const normalizedMin = min === '' ? 1 : min
        const normalizedMax = max === '' ? 1 : max
        if (
          !Number.isInteger(normalizedMin) ||
          normalizedMin < 1 ||
          !Number.isInteger(normalizedMax) ||
          normalizedMax < 1
        ) {
          return null
        }

        return {
          min: Math.min(normalizedMin, normalizedMax),
          max: Math.max(normalizedMin, normalizedMax),
        }
      }
      const itemDistributionRange = normalizeDistributionRange(
        this.reportEditParametersSnapshot.itemDistributionMode,
        this.reportEditParametersSnapshot.itemDistributionCountMin,
        this.reportEditParametersSnapshot.itemDistributionCountMax,
      )
      const spaceDistributionRange = normalizeDistributionRange(
        this.reportEditParametersSnapshot.spaceDistributionMode,
        this.reportEditParametersSnapshot.spaceDistributionCountMin,
        this.reportEditParametersSnapshot.spaceDistributionCountMax,
      )
      if (!itemDistributionRange || !spaceDistributionRange) {
        return
      }

      // 変更採用順に影響するパラメーターを変更した場合、別途グリッドUI側で指定している手動採用／不採用
      // との整合性が合わなくなる可能性があります。対処として、手動採用／不採用のクリアを促します。
      if (
        this.queryFilter.option.adoptOrder !==
          this.reportEditParametersSnapshot.adoptOrder ||
        this.queryFilter.option.orderAdjustment.optionsInSelection.selected !==
          this.reportEditParametersSnapshot.orderAdjustment.optionsInSelection
            .selected ||
        this.queryFilter.option.orderAdjustment.optionsInSelection.value !==
          this.reportEditParametersSnapshot.orderAdjustment.optionsInSelection
            .value ||
        this.queryFilter.option.orderAdjustment.unnecessarySelection
          .selected !==
          this.reportEditParametersSnapshot.orderAdjustment.unnecessarySelection
            .selected ||
        this.queryFilter.option.orderAdjustment.unnecessarySelection.value !==
          this.reportEditParametersSnapshot.orderAdjustment.unnecessarySelection
            .value ||
        this.queryFilter.option.orderAdjustment.priority !==
          this.reportEditParametersSnapshot.orderAdjustment.priority ||
        this.reportEditParameters.cutCount !==
          this.reportEditParametersSnapshot.cutCount
      ) {
        if (this.manualCut.ids.length > 0) {
          const confirmed = await new Promise(r => {
            // NOTE: ダイアログはPromiseじゃないのか...
            this.$dialog
              .open(DialogConfirmation, {
                message: '手動で設定した採用／不採用がクリアされます',
                subMessage: [
                  '変更採用順、および不採用接点算出に影響があるパラメーター（「採用順算出ベース」「採用順降下と不採用」）が変更されました。',
                  'パラメーターを反映させると、手動で設定した採用／不採用はクリアされます。',
                ],
                buttonTextOk: 'クリアして反映',
                buttonTextCancel: '戻る',
              })
              .subscribe(r)
          })

          if (!confirmed) {
            return
          }

          this.manualCut.candidates = []
          this.manualCut.ids = []
        }
      }

      this.queryFilter.leaf.columns[
        this.queryFilter.leaf.type
      ] = this.reportEditParametersSnapshot.leaf.columns.slice()
      this.queryFilter.option.adoptOrder = this.reportEditParametersSnapshot.adoptOrder
      this.queryFilter.option.orderAdjustment.optionsInSelection.selected = this.reportEditParametersSnapshot.orderAdjustment.optionsInSelection.selected
      this.queryFilter.option.orderAdjustment.optionsInSelection.value = this.reportEditParametersSnapshot.orderAdjustment.optionsInSelection.value
      this.queryFilter.option.orderAdjustment.unnecessarySelection.selected = this.reportEditParametersSnapshot.orderAdjustment.unnecessarySelection.selected
      this.queryFilter.option.orderAdjustment.unnecessarySelection.value = this.reportEditParametersSnapshot.orderAdjustment.unnecessarySelection.value
      this.queryFilter.option.orderAdjustment.priority = this.reportEditParametersSnapshot.orderAdjustment.priority
      this.queryFilter.option.facingMin = this.reportEditParametersSnapshot.facingMin
      this.queryFilter.option.facingMax = this.reportEditParametersSnapshot.facingMax
      this.queryFilter.option.restockCycleDays = this.reportEditParametersSnapshot.restockCycleDays
      this.queryFilter.option.stockCoefficientAll = this.reportEditParametersSnapshot.stockCoefficientAll
      this.queryFilter.option.stockCoefficient1st = this.reportEditParametersSnapshot.stockCoefficient1st
      this.queryFilter.option.stockCoefficient2nd = this.reportEditParametersSnapshot.stockCoefficient2nd

      this.reportEditParameters = {
        ...this.reportEditParameters,
        cutCount: this.reportEditParametersSnapshot.cutCount,
        maxPatternCount: this.reportEditParametersSnapshot.maxPatternCount,
        patternLabel: this.reportEditParametersSnapshot.patternLabel,
        cutLabel: this.reportEditParametersSnapshot.cutLabel,
        itemDistributionMode: this.reportEditParametersSnapshot
          .itemDistributionMode,
        itemDistributionCount: this.reportEditParametersSnapshot
          .itemDistributionCount,
        itemDistributionCountMin: itemDistributionRange.min,
        itemDistributionCountMax: itemDistributionRange.max,
        recommendsToDistributeItemCount: this.reportEditParametersSnapshot
          .recommendsToDistributeItemCount,
        spaceDistributionMode: this.reportEditParametersSnapshot
          .spaceDistributionMode,
        spaceDistributionCount: this.reportEditParametersSnapshot
          .spaceDistributionCount,
        spaceDistributionCountMin: spaceDistributionRange.min,
        spaceDistributionCountMax: spaceDistributionRange.max,
      }

      this.reloadGrids()
    },
    async reloadGrids() {
      this.customerCollection = []
      this.editReport = false

      setVisibleColumns(
        'leaf',
        this.resultTable.item.columns,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )
      setVisibleColumns(
        'segF',
        this.resultTable.segmentF.columns,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )
      setVisibleColumns(
        'segN',
        this.resultTable.segmentN.columns,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )

      this.resultTable.item.columns = this.resultTable.item.columns.map(c => c)
      this.resultTable.segmentF.columns = this.resultTable.segmentF.columns.map(
        c => c,
      )
      this.resultTable.segmentN.columns = this.resultTable.segmentN.columns.map(
        c => c,
      )
      this.resultTable.item.url = await this.composeItemDataUrl()
      this.resultTable.segmentF.url = await this.composeSegmentDataUrl('f')
      this.resultTable.segmentN.url = await this.composeSegmentDataUrl('n')
    },
    async showLeafDetail(itemCode) {
      this.activeResultTab = 'leaf_detail'
      this.focusingItemCode.leafDetail = itemCode

      const leafDetailUrl = await this.$longQuery.getQueryResultFetchUrl(
        'shin-tapir',
        this.queryId,
        `leaf_detail/${itemCode ? encodeURIComponent(itemCode) : ''}`,
      )

      this.resultTable.leafDetail.url = leafDetailUrl
    },
    async showStoreDetail(itemCode) {
      this.activeResultTab = 'store_detail'
      this.focusingItemCode.storeDetail = itemCode

      const storeDetailUrl = await this.$longQuery.getQueryResultFetchUrl(
        'shin-tapir',
        this.queryId,
        `store_detail/${itemCode ? encodeURIComponent(itemCode) : ''}`,
      )

      this.resultTable.storeDetail.url = storeDetailUrl
    },
    /**
     * 結果表示テーブルのサイズを更新する
     *
     * タブ内にさらにテーブル毎のタブがあるためなのか、画面初期ロード時にタブコンテンツの高さが
     * 極端に低いです。画面表示後に実サイズと合わせます。
     */
    updateTableSize(size) {
      if (sizeFixed) {
        return
      }
      if (!this.$refs.myMdTabs) {
        // 分析実行中などはまだ$elが存在しない
        return
      }

      const margin = 16

      // this.$refs.myMdTabs.$el.style.width = `${size.width + mergin * 2}px`
      // TapirMd/Mkでは最終的にこれは不要（しかもターゲットの要素は違う）だったんですが、
      // これしないと駄目でした。。
      this.$refs.myMdTabs.$el.style.height = `${size.height + margin * 2}px`

      const w = size.width
      const h = size.height - margin * 3 // TODO サイズ調整がかなり無理矢理…

      this.resultTable.item.width = w
      this.resultTable.item.height = h

      this.resultTable.segmentF.width = w
      this.resultTable.segmentF.height = h

      this.resultTable.segmentN.width = w
      this.resultTable.segmentN.height = h

      this.resultTable.leafDetail.width = w
      this.resultTable.leafDetail.height =
        h - this.resultTable.additionalExplanationHeightPx

      this.resultTable.storeDetail.width = w
      this.resultTable.storeDetail.height =
        h - this.resultTable.additionalExplanationHeightPx

      sizeFixed = true
    },
    toggleDetail(value) {
      this.isDetail = value

      this.customerCollection = []

      setVisibleColumns(
        'leaf',
        this.resultTable.item.columns,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )
      setVisibleColumns(
        'segF',
        this.resultTable.segmentF.columns,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )
      setVisibleColumns(
        'segN',
        this.resultTable.segmentN.columns,
        this.queryFilter.leaf.columns[this.queryFilter.leaf.type],
        this.isDetail,
        this.experimentalAi.segmentDescription.isVisibleInResult,
      )

      this.$refs.itemTable.init()
      this.$refs.segmentFTable.init()
      this.$refs.segmentNTable.init()
    },
    /**
     * 商品データ取得URL作成
     *
     * 複数箇所で行う & ちょっと複雑になってきたので独立
     */
    async composeItemDataUrl() {
      const params = new URLSearchParams()
      const append = (key, value) => {
        params.append(key, value)

        if (this.experimentalAi.enabled) {
          this.experimentalAi.parameterSnapshot[key] = value
        }
      }

      // 採用順算出ベース
      append('adoptOrder', this.queryFilter.option.adoptOrder)

      // 採用順降下条件
      append(
        'orderAdjustment1',
        this.queryFilter.option.orderAdjustment.optionsInSelection.selected
          ? this.queryFilter.option.orderAdjustment.optionsInSelection.value
          : 0,
      )
      append(
        'orderAdjustment2',
        this.queryFilter.option.orderAdjustment.unnecessarySelection.selected
          ? this.queryFilter.option.orderAdjustment.unnecessarySelection.value /
              100
          : 0,
      )
      append(
        'orderAdjustmentPriority',
        this.queryFilter.option.orderAdjustment.priority ===
          'optionsInSelection'
          ? 1
          : 2,
      )
      append(
        'cutWhenApplicable',
        this.queryFilter.option.orderAdjustment.cutWhenApplicable ? 1 : 0,
      )

      // 不採用
      append('cutCount', this.reportEditParameters.cutCount)

      // 棚割パターン割付
      append('maxPatternCount', this.reportEditParameters.maxPatternCount)
      append('patternLabel', this.reportEditParameters.patternLabel)
      append('cutLabel', this.reportEditParameters.cutLabel)
      append('facingMin', this.queryFilter.option.facingMin)
      append('facingMax', this.queryFilter.option.facingMax)
      append('restockCycleDays', this.queryFilter.option.restockCycleDays)

      // 在庫係数
      append('stockCoefficientAll', this.queryFilter.option.stockCoefficientAll)
      append('stockCoefficient1st', this.queryFilter.option.stockCoefficient1st)
      append('stockCoefficient2nd', this.queryFilter.option.stockCoefficient2nd)

      // 販促単品分配
      append(
        'itemDistributionCount',
        this.reportEditParameters.itemDistributionMode === 'count'
          ? this.reportEditParameters.itemDistributionCount
          : 0,
      )
      append(
        'itemDistributionCountMin',
        this.reportEditParameters.itemDistributionMode === 'range'
          ? this.reportEditParameters.itemDistributionCountMin
          : 0,
      )
      append(
        'itemDistributionCountMax',
        this.reportEditParameters.itemDistributionMode === 'range'
          ? this.reportEditParameters.itemDistributionCountMax
          : 0,
      )
      if (this.reportEditParameters.recommendsToDistributeItemCount !== 'all') {
        append(
          'recommendsToDistributeItemCount',
          this.reportEditParameters.recommendsToDistributeItemCount,
        )
      }

      // 理論スペース分配
      append(
        'spaceDistributionCount',
        this.reportEditParameters.spaceDistributionMode === 'count'
          ? this.reportEditParameters.spaceDistributionCount
          : 0,
      )
      append(
        'spaceDistributionCountMin',
        this.reportEditParameters.spaceDistributionMode === 'range'
          ? this.reportEditParameters.spaceDistributionCountMin
          : 0,
      )
      append(
        'spaceDistributionCountMax',
        this.reportEditParameters.spaceDistributionMode === 'range'
          ? this.reportEditParameters.spaceDistributionCountMax
          : 0,
      )

      // 手動不採用
      if (this.manualCut.ids.length > 0) {
        append('manualCutToggle', this.manualCut.ids.join(','))
      }

      return await this.$longQuery.getQueryResultFetchUrl(
        'shin-tapir',
        this.queryId,
        `item?${params.toString()}`,
      )
    },
    /**
     * セグメントデータ取得URLを作成する
     */
    async composeSegmentDataUrl(segment) {
      const params = new URLSearchParams()
      const append = (key, value) => params.append(key, value)

      append('company', this.queryFilter.marketItems.item.company)
      append('adoptOrder', this.queryFilter.option.adoptOrder)
      append(
        'orderAdjustment1',
        this.queryFilter.option.orderAdjustment.optionsInSelection.selected
          ? this.queryFilter.option.orderAdjustment.optionsInSelection.value
          : 0,
      )
      append(
        'orderAdjustment2',
        this.queryFilter.option.orderAdjustment.unnecessarySelection.selected
          ? this.queryFilter.option.orderAdjustment.unnecessarySelection.value /
              100
          : 0,
      )
      append(
        'orderAdjustmentPriority',
        this.queryFilter.option.orderAdjustment.priority ===
          'optionsInSelection'
          ? 1
          : 2,
      )
      append('cutCount', this.reportEditParameters.cutCount)
      append(
        'itemDistributionCount',
        this.reportEditParameters.itemDistributionMode === 'count'
          ? this.reportEditParameters.itemDistributionCount
          : 0,
      )
      append(
        'itemDistributionCountMin',
        this.reportEditParameters.itemDistributionMode === 'range'
          ? this.reportEditParameters.itemDistributionCountMin
          : 0,
      )
      append(
        'itemDistributionCountMax',
        this.reportEditParameters.itemDistributionMode === 'range'
          ? this.reportEditParameters.itemDistributionCountMax
          : 0,
      )
      if (this.reportEditParameters.recommendsToDistributeItemCount !== 'all') {
        append(
          'recommendsToDistributeItemCount',
          this.reportEditParameters.recommendsToDistributeItemCount,
        )
      }
      append(
        'spaceDistributionCount',
        this.reportEditParameters.spaceDistributionMode === 'count'
          ? this.reportEditParameters.spaceDistributionCount
          : 0,
      )
      append(
        'spaceDistributionCountMin',
        this.reportEditParameters.spaceDistributionMode === 'range'
          ? this.reportEditParameters.spaceDistributionCountMin
          : 0,
      )
      append(
        'spaceDistributionCountMax',
        this.reportEditParameters.spaceDistributionMode === 'range'
          ? this.reportEditParameters.spaceDistributionCountMax
          : 0,
      )
      if (this.manualCut.ids.length > 0) {
        append('manualCutToggle', this.manualCut.ids.join(','))
      }

      return await this.$longQuery.getQueryResultFetchUrl(
        'shin-tapir',
        this.queryId,
        `segment/${segment}?${params.toString()}`,
      )
    },
    // 採用順降下条件に合致する顧客設定数を取得します
    async getOrderAdjustedCount(params) {
      if (!this.queryId) {
        return 0
      }
      if (
        params.orderAdjustment.optionsInSelection.selected === false &&
        params.orderAdjustment.unnecessarySelection.selected === false
      ) {
        // 採用順降下条件が両方とも無効なら不採用候補数は必ず0（そもそも表示しないけど...）
        return 0
      }

      const queryParams = new URLSearchParams()
      const append = (key, value) => queryParams.append(key, value)

      // 採用順算出ベース
      append('adoptOrder', params.adoptOrder)

      // 採用順降下条件
      append(
        'orderAdjustment1',
        params.orderAdjustment.optionsInSelection.selected
          ? params.orderAdjustment.optionsInSelection.value
          : 0,
      )
      append(
        'orderAdjustment2',
        params.orderAdjustment.unnecessarySelection.selected
          ? params.orderAdjustment.unnecessarySelection.value / 100
          : 0,
      )
      append(
        'orderAdjustmentPriority',
        params.orderAdjustment.priority === 'optionsInSelection' ? 1 : 2,
      )

      try {
        const count = await repository.giggle
          .get(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/order_adjustment_estimate?${queryParams.toString()}`,
          )
          .then(r => r.data)
        return count
      } catch (error) {
        return null
      }
    },
    applyManualCut() {
      this.manualCut.ids = this.manualCut.candidates.slice()
      this.experimentalAi.parameterSnapshot.manualCutToggle = this.manualCut.ids.join(
        ',',
      )
      this.reloadGrids()
    },
    resetManualCut() {
      this.manualCut.candidates = this.manualCut.ids.slice()
      this.reloadGrids()
    },
    clearManualCut() {
      this.manualCut.candidates = []
      this.manualCut.ids = []
      delete this.experimentalAi.parameterSnapshot.manualCutToggle
      this.reloadGrids()
    },
    async generateSegmentDescription() {
      this.experimentalAi.segmentDescription.isAiGenerating = true
      this.experimentalAi.isInInterval = true

      try {
        await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_description/generate`,
            this.experimentalAi.parameterSnapshot,
          )
          .then(r => r.data)

        this.experimentalAi.segmentDescription.hasGenerated = true
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.segmentDescription.isAiGenerating = false
        sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
          this.experimentalAi.isInInterval = false
        })
      }
      if (this.experimentalAi.segmentDescription.isVisibleInResult) {
        // AI要約を表示中（原則これは再作成時）なのでグリッド更新が必要
        this.reloadGrids()
      }
    },
    async generateNewItemSuggestion() {
      this.experimentalAi.newItemSuggestion.isAiGenerating = true
      this.experimentalAi.newItemSuggestion.suggestions = []
      this.experimentalAi.isInInterval = true

      try {
        const generatedSuggestion = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_new_item_suggestion/generate`,
            this.experimentalAi.parameterSnapshot,
          )
          .then(r => r.data)

        this.experimentalAi.newItemSuggestion.suggestions = generatedSuggestion
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.newItemSuggestion.isAiGenerating = false
        sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
          this.experimentalAi.isInInterval = false
        })
      }
    },
    async generateNewItemPositionSuggestion() {
      this.experimentalAi.newItemPositionSuggestion.isAiGenerating = true
      this.experimentalAi.newItemPositionSuggestion.suggestions = []
      this.experimentalAi.isInInterval = true

      try {
        const generatedSuggestion = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_new_item_position_suggestion/generate`,
            {
              ...this.experimentalAi.parameterSnapshot,
              newItemData: this.experimentalAi.newItemPositionSuggestion
                .newItemData,
            },
          )
          .then(r => r.data)

        this.experimentalAi.newItemPositionSuggestion.suggestions = generatedSuggestion
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.newItemPositionSuggestion.isAiGenerating = false
        sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
          this.experimentalAi.isInInterval = false
        })
      }
    },
    applyCutCandidateRecommendationToManualCut() {
      const uniqueCandidates = Array.from(
        new Set([
          ...this.manualCut.candidates,
          ...this.experimentalAi.cutCandidateRecommendation.excludedItems,
        ]),
      )
      const hasOverflow = uniqueCandidates.length > this.manualCut.max

      if (hasOverflow) {
        alert(
          `手動不採用に設定できる件数は最大${
            this.manualCut.max
          }件です。超過分は反映されません。`,
        )
      }

      this.manualCut.candidates = hasOverflow
        ? uniqueCandidates.slice(0, this.manualCut.max)
        : uniqueCandidates
      this.applyManualCut()
      this.experimentalAi.cutCandidateRecommendation.isDialogOpen = false
    },
    async generateCutCandidateRecommendation() {
      this.experimentalAi.cutCandidateRecommendation.isAiGenerating = true
      this.experimentalAi.cutCandidateRecommendation.recommendations = []
      this.experimentalAi.cutCandidateRecommendation.excludedItems = []
      this.experimentalAi.isInInterval = true

      try {
        await sleep(3000)
        const generatedRecommendations = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_cut_candidate_recommendation/generate`,
            this.experimentalAi.parameterSnapshot,
          )
          .then(r => r.data)

        this.experimentalAi.cutCandidateRecommendation.recommendations = generatedRecommendations

        if (
          this.experimentalAi.cutCandidateRecommendation.recommendations
            .length === 0
        ) {
          this.$dialog.open(
            DialogWarning,
            'この分析結果へのカットのレコメンドはありません',
          )
        }
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.cutCandidateRecommendation.isAiGenerating = false
        sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
          this.experimentalAi.isInInterval = false
        })
      }
    },
    async generateRecommendNonSalesStoresDownloadLink() {
      this.experimentalAi.recommendNonSalesStores.isAiGenerating = true
      this.experimentalAi.recommendNonSalesStores.downloadUrls = []
      this.experimentalAi.isInInterval = true

      try {
        const generatedListDataUrls = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_recommend_non_sales_stores/generate`,
            {
              ...this.experimentalAi.parameterSnapshot,
              includeThirdRecommend: this.experimentalAi.recommendNonSalesStores
                .includeThirdRecommend,
            },
          )
          .then(r => r.data)

        this.experimentalAi.recommendNonSalesStores.downloadUrls = generatedListDataUrls
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.recommendNonSalesStores.isAiGenerating = false
        sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
          this.experimentalAi.isInInterval = false
        })
      }
    },
    async downloadPlanogramColoringFile(parent) {
      if (this.experimentalAi.planogramSoftwareColoringFile.isAiGenerating) {
        return
      }

      this.experimentalAi.planogramSoftwareColoringFile.isAiGenerating = true
      // これはインターバルいいか...
      // this.experimentalAi.isInInterval = true

      try {
        await sleep(3000)
        const generatedMapping = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_planogram_software_coloring/generate`,
            {
              ...this.experimentalAi.parameterSnapshot,
              parent,
            },
          )
          .then(r => r.data)

        // ちょっと雑なCSV処理なので一旦共通関数にはしません
        const _escape = v => {
          let output = v
          let shouldEnclose = false

          if (output.includes('"')) {
            output = output.replaceAll('"', '""')
            shouldEnclose = true
          }
          if (output.includes(',')) {
            shouldEnclose = true
          }

          if (shouldEnclose) {
            return `"${output}"`
          }

          return output
        }

        //ヘッダ
        const header = '商品コード,親コード'
        let csv = `${header}\n`

        //データ
        generatedMapping.forEach(mapping => {
          const itemCode = _escape(mapping[0])
          const parentValue = _escape(mapping[1])

          csv += `${itemCode},${parentValue}`
          csv += '\n'
        })

        const bom = new Uint8Array([0xef, 0xbb, 0xbf]) //BOM
        const blob = new Blob([bom, csv], { type: 'text/csv' })

        download(blob, 'data.csv')
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.planogramSoftwareColoringFile.isAiGenerating = false
        // sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
        //   this.experimentalAi.isInInterval = false
        // })
      }
    },
    async generateCouponTargetCustomer() {
      this.experimentalAi.couponTargetCustomerFile.isAiGenerating = true
      this.experimentalAi.couponTargetCustomerFile.existingItemCodes = []
      this.experimentalAi.couponTargetCustomerFile.hasGenerated = false
      this.experimentalAi.isInInterval = true

      try {
        const generatedCouponTargetCustomer = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_coupon_target_customer/generate`,
            {
              ...this.experimentalAi.parameterSnapshot,
              itemCodes: this.experimentalAi.couponTargetCustomerFile
                .itemCodesInput,
            },
          )
          .then(r => r.data)

        this.experimentalAi.couponTargetCustomerFile.existingItemCodes =
          generatedCouponTargetCustomer.items
        this.experimentalAi.couponTargetCustomerFile.customerCountSegF =
          generatedCouponTargetCustomer.customerCountSegF
        this.experimentalAi.couponTargetCustomerFile.customerCountSegN =
          generatedCouponTargetCustomer.customerCountSegN
        this.experimentalAi.couponTargetCustomerFile.customerCountLeaf =
          generatedCouponTargetCustomer.customerCountLeaf

        this.experimentalAi.couponTargetCustomerFile.hasGenerated = true

        if (
          this.experimentalAi.couponTargetCustomerFile.existingItemCodes.filter(
            e => e.exists,
          ).length === 0
        ) {
          this.$dialog.open(
            DialogWarning,
            '入力された商品コードはどれも分析結果に存在しません',
          )
        }
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.couponTargetCustomerFile.isAiGenerating = false
        sleep(this.experimentalAi.intervalSeconds * 1000).then(() => {
          this.experimentalAi.isInInterval = false
        })
      }
    },
    async downloadCouponTargetCustomerFile(scope) {
      this.experimentalAi.couponTargetCustomerFile.isAiGenerating = true

      try {
        const urls = await repository.giggle
          .post(
            `/api/shin-tapir/${
              this.queryId
            }/fetch/experimental/ai_coupon_target_customer_url/generate`,
            {
              ...this.experimentalAi.parameterSnapshot,
              // ユーザー入力を見てしまうと人数を算出したときの入力と同一かどうか分からないので、
              // 生成された存在確認が取れている商品コードを送るようにします。
              // API側は改行区切りのStringを受け付けるように揃えているので、ちょっと微妙ですが
              // String化して送ります。
              itemCodes: this.experimentalAi.couponTargetCustomerFile.existingItemCodes
                .filter(e => e.exists)
                .map(e => e.itemCode)
                .join('\n'),
              scope,
            },
          )
          .then(r => r.data)

        for (const url of urls) {
          window.open(url, '_blank', 'noopener')
        }
      } catch (e) {
        alert('生成できませんでした...時間をおいて再度お試しください。')
      } finally {
        this.experimentalAi.couponTargetCustomerFile.isAiGenerating = false
      }
    },
    async copyAiSuggestionToClipboard(suggestions_or_value, columns) {
      try {
        if (typeof suggestions_or_value === 'string' && columns === undefined) {
          // 値をそのままコピー
          await navigator.clipboard.writeText(suggestions_or_value)
        } else {
          await this.copyArrayToClipboardAsTSV(suggestions_or_value, columns)
        }
      } catch (e) {
        this.$dialog.open(
          DialogWarning,
          'クリップボードへのコピーに失敗しました。ブラウザの権限設定をご確認のうえ、再度お試しください。',
        )
        return
      }

      this.experimentalAi.showClipboardCopiedMessage = true
      await new Promise(r => setTimeout(r, 1500))
      this.experimentalAi.showClipboardCopiedMessage = false
    },
    /**
     * オブジェクトの配列をTSV形式でクリップボードにコピーする
     *
     * @param {Array<Object>} data
     * @param {Array<String>} columns 出力する列名
     */
    copyArrayToClipboardAsTSV(data, columns) {
      const getColumnName = c => (Array.isArray(c) ? c[0] : c)
      const getColumnLabel = c => (Array.isArray(c) ? c[1] : c)

      const header = columns.map(getColumnLabel).join('\t')
      const body = data.map(row =>
        columns
          .map(getColumnName)
          .map(col => {
            const value = row[col]
            if (!value) {
              return ''
            }
            return String(value).replace(/\t/g, ' ') // タブ文字はスペースに置換
          })
          .join('\t'),
      )

      return navigator.clipboard.writeText([header, ...body].join('\n'))
    },
  },
  mounted() {
    // MdTabsを配置すると横幅が大きくなる（左サイドバーの分？）なので、
    // 無理矢理横スクロールが出ないようにする。
    // グリッドサイズは別途合わせて調整している。
    document.querySelector('html').style.overflowX = 'hidden'

    const subscription = this.orderAdjustmentParamChangeSubject
      .asObservable()
      .pipe(
        tap(() => {
          this.reportEditParameters.isCalculatingCutCandidatesCount = true
        }),
        debounceTime(750),
        distinctUntilChanged(),
        map(value => JSON.parse(value)),
        switchMap(async params => this.getOrderAdjustedCount(params)),
      )
      .subscribe(result => {
        this.reportEditParameters.isCalculatingCutCandidatesCount = false
        this.reportEditParameters.cutCandidatesCount = result
      })

    this.$on('hook:beforeDestroy', () => subscription.unsubscribe())
  },
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: var(--spacing-medium);
}

.option-sub-box {
  margin-left: var(--spacing-medium);
  padding-left: var(--spacing-medium);
  padding-bottom: var(--spacing-medium);
  border-left: 2px solid var(--color-border);
}

.option-changeable {
  position: relative;

  margin-left: var(--spacing-small);

  &:after {
    position: absolute;
    left: 100%;
    word-break: keep-all;
    font-size: var(--font-size-small);
    color: #4db6ac;
    content: '分析後に結果画面で変更可能です';
  }

  i {
    transform: scale(0.7) translateY(-2px);
    color: #4db6ac !important;
  }
}

.report-edit-dialog-block {
  $block: &;

  border: 1px solid var(--color-border);
  border-radius: 5px;
  padding: var(--spacing-medium);

  margin-top: var(--spacing-medium);

  &--highlight {
    border: 2px solid #4db6ac;

    #{$block}__title {
      color: #4db6ac;
    }

    order: 1;
  }

  order: 2;

  // 何故かこのブロック内の要素の高さが他より高くなってしまうので調整
  .md-field {
    min-height: 0;
  }
}

// .radio-buttons {
//   display: flex;
//
//   &.vertical {
//     flex-direction: column;
//   }
// }
//
.md-tabs {
  // 結果エリア内のタブに分析結果が入る場合、結果エリアからの
  // マージンがspacing-largeあり、タブ内がspacing-mediumある。
  // 少々マージンを取りすぎなので、グリッドまでが通常のspacing-large
  // になるように調整する。
  // node-sassのバージョン（？）のせいなのかコンパイルされたあとのCSSが
  // "calc(var(--spacing-large) - var(--spacing-medium))"となってしまっていたので
  // ひとまず固定値にした。
  // margin: calc(0px - (var(--spacing-large) - var(--spacing-medium)));
  margin: -16px;
}

.dangerous-option {
  border: 2px solid var(--color-warn);
  margin-top: var(--spacing-large);
  padding: var(--spacing-medium);
}

.additional-table-explanation {
  font-size: var(--font-size-small);

  &__tips {
    color: var(--color-secondary-text);
  }

  &__important-tips {
    color: var(--color-warn);
  }
}

.md-menu-content {
  z-index: 9999;
}

.experimental-ai-menu-section {
  padding: 12px 16px 4px;
  color: var(--color-secondary-text);
  font-size: var(--font-size-small);
  font-weight: bold;
}

.experimental-ai-menu-section--bordered {
  margin-top: 4px;
  border-top: 1px solid var(--color-border);
  padding-top: 12px;
}

.experimental-ai-menu-item {
  display: block;
}

.new-item-suggestion-table,
.recommend-non-sales-stores-download-links,
.coupon-target-customer-links {
  margin-top: var(--spacing-medium);
  border: 3px dotted var(--color-primary);
  border-radius: 5px;
}

.disabled-link {
  color: var(--color-secondary-text) !important;
  text-decoration: none !important;
  cursor: default !important;
  pointer-events: none;
}
</style>

<!-- グリッドのセルに直接付与するのでScopedにできない -->
<style lang="scss">
.manual-cut-toggle {
  &::before {
    position: absolute;
    left: 16px;
    opacity: 0;
  }

  &::before {
    // 未確定表示（デフォ）
    content: '🔃';
    font-size: 13px;
    font-weight: bold;
    color: gray;
  }
  &--cut::before {
    // 手動カットされた
    content: '✂️';
  }
  &--alive::before {
    // 手動キープされた
    content: '♻️';
  }

  &:hover::before {
    opacity: 0.3;
  }

  &--visible::before {
    opacity: 0.8;
  }
}
</style>
